const filterJson = {
  'joint': [
    {
      title: '关节数',
      key: '个',
      zhName: '个',
      desc: '单位：个，有效范围0-28',
      scale: 1,
      min: 0,
      max: 28
    }
  ],
  'redBloodSedimentationRate': [
    {
      title: '红细胞沉降率',
      key: 'mm/h',
      zhName: '毫米每小时',
      scale: 1,
      min: 0
    }
  ],
  'sisualSimulationRating': [
    {
      title: '视觉模拟评分',
      key: '分',
      zhName: '分',
      desc: '有效范围0-100',
      scale: 1,
      min: 0,
      max: 100
    }
  ],
  'cholesterol.hdl': [
    {
      title: '高密度脂蛋白',
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '正常范围： 0 - 50 mg/dL <br>有效范围： 0 - 773 mg/dL',
      scale: 100,
      min: 0,
      max: 773
    },
    {
      title: '高密度脂蛋白',
      key: 'g/L',
      zhName: '克每升',
      desc: '正常范围： 0 - 0.5 g/L <br>有效范围： 0 - 7.73 g/L',
      scale: 1,
      min: 10,
      max: 1000
    }
  ],
  // 心血管风险-总胆固醇
  'cholesterol': [
    {
      title: '胆固醇',
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '正常范围： 0 - 201 mg/dL <br>有效范围： 0 - 773 mg/dL',
      scale: 100,
      min: 0,
      max: 773

    },
    {
      title: '胆固醇',
      key: 'g/L',
      zhName: '克每升',
      desc: '正常范围： 0 - 2.01 g/L <br>有效范围： 0 - 7.73 g/L',
      scale: 1,
      min: 0,
      max: 7.73
    }
  ],
  'vo2': [
    {
      title: 'VO₂',
      key: 'mL/min',
      zhName: '毫升每分',
      desc: '有效范围： 10 - 1000 mL/min',
      scale: 1,
      min: 10,
      max: 1000
    }
  ],
  'vo2.copy': [
    {
      title: 'VO₂',
      key: 'ml/min',
      zhName: '毫升每分',
      desc: '有效范围： 0 - 999 mL/min',
      scale: 1,
      min: 0,
      max: 999
    }
  ],
  'fraction.oxygen-saturation.arterial': [
    {
      title: '氧饱和度',
      key: '%',
      zhName: '百分比',
      desc: '有效范围： 10 - 100 %',
      scale: 1,
      min: 10,
      max: 100
    }
  ],
  'fraction.oxygen-saturation.venous': [
    {
      title: '氧饱和度',
      key: '%',
      zhName: '百分比',
      desc: '有效范围： 10 - 100 %',
      scale: 1,
      min: 10,
      max: 100
    }
  ],
  // 'base.be': [
  //   {
  //     title: '碱剩余',
  //     key: 'mEq/L',
  //     zhName: '毫当量每升',
  //     desc: '正常范围： [-4,4]mEq/L <br>有效范围： [-50,50] mEq/L',
  //     scale: 1,
  //     min: -50,
  //     max: 50
  //   },
  //   {
  //     title: '碱剩余',
  //     key: 'mmol/L',
  //     zhName: '毫摩尔每升',
  //     desc: '正常范围： [-4,4]mmol/L <br>有效范围： [-50,50] mmol/L',
  //     scale: 1,
  //     min: -50,
  //     max: 50
  //   }
  // ],
  // 潮气量
  'volume.tidal': [
    {
      title: '潮气量',
      key: 'L',
      zhName: '升',
      desc: '有效范围： 0.05 - 3 L',
      scale: 1,
      min: 0.05,
      max: 3
    },
    {
      title: '潮气量',
      key: 'mL',
      zhName: '毫升',
      desc: '有效范围： 50 - 3000 mL',
      scale: 1000,
      min: 50,
      max: 3000
    }
  ],
  // 尿素
  'purea': [
    {
      title: '血尿素',
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '有效范围： 1 - 2102 mg/dL',
      scale: 1,
      min: 1,
      max: 2102
    },
    {
      title: '血尿素',
      key: 'mg/L',
      zhName: '毫克每升',
      desc: '有效范围： 6 - 21021 mg/L',
      scale: 10,
      min: 6,
      max: 21021
    }
  ],
  'bun': [
    {
      title: '血尿素氮',
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '正常范围： 6 - 20 mg/dL <br>有效范围： 0.1 - 1000 mg/dL',
      scale: 1,
      min: 0.1,
      max: 1000
    }
  ],
  // 尿尿素
  'uurea': [{
    title: '尿尿素',
    key: 'mg/dL',
    zhName: '毫克每分升',
    desc: '有效范围： ≤40076mg/dL',
    scale: 1,
    min: 1,
    max: 40076
  },
  {
    title: '尿尿素',
    key: 'mmol/L',
    zhName: '毫摩尔每升',
    desc: '正常范围：≤9999mmol/L',
    scale: 0.2495,
    min: 1,
    max: 9999
  }],
  // 总失血量
  'volume.liter,milliliter': [
    {
      key: 'L',
      zhName: '升',
      desc: '有效范围： 任何数值',
      scale: 0.001,
      title: '血红蛋白'
    },
    {
      key: 'mL',
      zhName: '毫升',
      desc: '有效范围： 任何数值',
      scale: 1,
      title: '血红蛋白'
    }
  ],
  // 血红蛋白
  'hemoglobin.blood': [

    {
      key: 'g/dL',
      zhName: '克每分升',
      desc: '有效范围： 1 - 30 g/dL',
      scale: 0.1,
      min: 1,
      max: 30,
      title: '血红蛋白'
    },
    {
      key: 'g/L',
      zhName: '克每升',
      desc: '有效范围： 10 - 300 g/L',
      scale: 1,
      min: 10,
      max: 300,
      title: '血红蛋白'
    }
  ],
  /** 输液总量 */
  'volume.infusion': [
    {
      key: 'L',
      zhName: '升',
      desc: '有效范围： ≤ 9 L',
      scale: 0.001,
      min: 0,
      max: 9,
      title: '体积'
    },
    {
      key: 'mL',
      zhName: '毫升',
      desc: '有效范围： ≤ 9000 mL',
      scale: 1,
      min: 0,
      max: 9000,
      title: '体积'
    }
  ],
  /** 预计时间 */
  'periodoftime.infusion': [
    {
      title: '时间段',
      key: 'h',
      zhName: '小时',
      desc: '有效范围： ≤ 24h',
      scale: 1 / 60,
      min: 0,
      max: 24
    },
    {
      title: '时间段',
      key: 'min',
      zhName: 'minute',
      desc: '有效范围： ≤ 1440 min',
      scale: 1,
      min: 0,
      max: 1440
    }
  ],
  /** 每毫升滴数（预设） */
  'dropfactor': [
    {
      title: '点滴因子',
      key: '滴/mL',
      zhName: '滴每毫升',
      desc: '有效范围： ≤ 99滴/mL',
      scale: 1,
      min: 0,
      max: 99
    }
  ],
  /** 年龄 */
  'age.adult': [
    {
      key: '岁',
      zhName: '岁',
      desc: '有效范围： 16 - 130 岁',
      scale: 1,
      min: 16,
      max: 130
    }
  ],
  'age.child': [
    {
      key: '岁',
      zhName: '岁',
      desc: '有效范围： 2 - 16 岁',
      scale: 1,
      min: 2,
      max: 16
    }
  ],
  'age_copy': [
    {
      key: '岁',
      scale: 1,
      min: 1,
      max: 130
    }
  ],
  'age_copy2': [
    {
      key: '岁',
      scale: 1,
      desc: '有效范围： 0 - 120 岁',
      min: 1,
      max: 120
    }
  ],
  'age_copy3': [
    {
      key: '岁',
      scale: 1,
      desc: '有效范围： 0 - 130 岁',
      min: 1,
      max: 130
    }
  ],
  /** 年龄 */
  'age.child.yue': [
    {
      key: '月',
      zhName: '月',
      desc: '有效范围： 1 - 12 月',
      scale: 1,
      min: 1,
      max: 12
    }
  ],
  'age.child.sui': [
    {
      key: '岁',
      zhName: '岁',
      desc: '有效范围： 1 - 18 岁',
      scale: 1,
      min: 1,
      max: 18
    }
  ],
  /** 血小板计数 */
  'platelet': [
    {
      key: '/mm <sup>3</sup>',
      zhName: '细胞每立方毫米',
      desc: '正常范围： 150000 - 350000/mm <sup>3</sup><br>有效范围： 100 - 2000000 /mm <sup>3</sup>',
      scale: 1000,
      min: 100,
      max: 2000000
    },
    {
      key: 'x10<sup>9</sup>/L',
      zhName: 'x10<sup>9</sup>每升',
      desc: '正常范围： 150 - 350/mm <sup>3</sup><br>有效范围： 0 - 2000 x10<sup>9</sup>/L',
      scale: 1,
      min: 0,
      max: 2000
    }
  ],
  /** 凝血酶原时间 */
  'prothrombin.second': [{
    key: 's',
    zhName: '秒',
    desc: '有效范围： 任何数值',
    scale: 1
  }],
  /** c-反应蛋白 */
  'crp': [
    {
      key: 'mg/L',
      zhName: '毫克每升',
      desc: '正常范围： ≤ 1 mg/L <br>有效范围： 0 - 500 mg/L',
      scale: 10,
      min: 0,
      max: 500
    },
    {
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '正常范围： ≤ 0.1 mg/dL <br>有效范围： 0 - 50 mg/dL',
      scale: 1,
      min: 0,
      max: 50
    }
  ],
  /** 白细胞计数 */
  'whitecellcount': [
    {
      key: '/mm <sup>3</sup>',
      zhName: '细胞每立方毫米',
      desc: '有效范围： 1 - 200000/mm <sup>3</sup>',
      scale: 1000,
      min: 1,
      max: 200000
    },
    {
      key: 'x10<sup>9</sup>/L',
      zhName: 'x10<sup>9</sup>每升',
      desc: '有效范围： 0 - 200 x10<sup>9</sup>/L',
      scale: 1,
      min: 0,
      max: 200
    }
  ],
  /** 血红蛋白 */
  'hemoglobin': [
    {
      key: 'g/dL',
      zhName: '克每分升',
      desc: '有效范围： 1 - 30 g/dL',
      scale: 10,
      min: 1,
      max: 30
    },
    {
      key: 'g/L',
      zhName: '克每升',
      desc: '有效范围： 1 - 300 g/L',
      scale: 10,
      min: 1,
      max: 300
    }
    /* { // 国权说不要
      key:'mmol/L',
      zhName:'毫摩尔每升',
      desc:'有效范围： 0.6 - 18.6 mmol/L',
      scale:1,
      min:0.6,
      max:18.6,
    }, */
  ],
  /** 纠正速率 */
  'correction.rate': [{
    key: 'mmol/L',
    zhName: '毫摩尔每升',
    desc: '有效范围：≤5mmol/L',
    scale: 1,
    min: 0,
    max: 5
  }],
  /** 血清 Na */
  'sodium.serum': [
    {
      key: 'mEq/L',
      zhName: '毫当量每升',
      desc: '正常范围： 136 - 146 mEq/L <br>有效范围： 90 - 190 mg/L',
      scale: 1,
      min: 90,
      max: 190
    },
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '正常范围： 136 - 146 mmol/L <br>有效范围： 90 - 190 mmol/L',
      scale: 1,
      min: 90,
      max: 190
    }
  ],
  // 尿钠
  'nn': [
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '有效范围： 0 - 300 mmol/L',
      scale: 1,
      min: 0,
      max: 300
    }
  ],
  /** 肌酐 - 血肌酐 */
  'creatinine.serum': [
    {
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '有效范围： 0.1 - 56.6 mg/dL',
      scale: 1,
      min: 0.1,
      max: 56.6
    },
    {
      key: 'mg/L',
      zhName: '毫克每升',
      desc: '有效范围： 1 - 566 mg/L',
      scale: 10,
      min: 1,
      max: 566
    },
    {
      key: 'umol/L',
      zhName: '微摩尔每升',
      desc: '有效范围： 10 - 5000 umol/L',
      scale: 88.417,
      min: 10,
      max: 5000
    }
  ],
  /** 血肌酐 */
  'serum.creatinine': [
    {
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '有效范围： 0.1 - 56.6 mg/dL',
      scale: 1,
      min: 0.1,
      max: 56.6
    },
    {
      key: 'umol/L',
      zhName: '微摩尔每升',
      desc: '有效范围： 10 - 5000 umol/L',
      scale: 88.417,
      min: 10,
      max: 5000
    }
  ],
  // 尿量
  'urine': [
    {
      key: 'L',
      zhName: '升',
      desc: '有效范围： ≤99L',
      scale: 1,
      min: 0,
      max: 99
    },
    {
      key: 'ml',
      zhName: '毫升',
      desc: '有效范围： ≤99000ml',
      scale: 1000,
      min: 0,
      max: 99000
    }
  ],
  /** 糖 - 血糖 */
  'glucose.blood': [
    {
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '正常范围： 70 - 110 mg/dL <br>有效范围： 2 - 2883 mg/dL',
      scale: 18.03,
      min: 2,
      max: 2883
    },
    {
      key: 'g/L',
      zhName: '克每升',
      desc: '正常范围： 0.7 - 1.1 g/L <br>有效范围： 0 - 28.8 g/L',
      scale: 0.1803,
      min: 0,
      max: 28.8
    },
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '正常范围： 3.9 - 6.1 mmol/L <br>有效范围： 0.1 - 160 mmol/L',
      scale: 1,
      min: 0.1,
      max: 160
    }
  ],
  /** 胰岛素 */
  insulin: [
    {
      key: 'mU/L',
      zhName: '',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0
    }
  ],
  /** 红细胞比容 */
  'hematocrit.percent': [
    {
      key: '%',
      zhName: '百分比',
      desc: '有效范围： 5 - 90 %',
      scale: 1,
      min: 5,
      max: 90
    }
  ],

  /** 体重 */
  'weight.bodyweight': [
    {
      key: 'kg',
      zhName: '千克',
      desc: '有效范围： 0.3 - 400 kg',
      scale: 1,
      min: 0.3,
      max: 400,
      title: '体重'
    }
    // {
    //   key: 'lb',
    //   zhName: '磅',
    //   desc: '有效范围： 1 - 882 lb',
    //   scale: 2.2046,
    //   min: 1,
    //   max: 882,
    //   title: '体重'
    // }
    /* { // 国权说不要
      key:'st+lb',
      zhName:'英石和磅',
      desc:'有效范围： 1lb - 62 st 14 lb',
      scale:1,
      min:1,
      max:882,
    },
    {
      key:'lb+oz',
      zhName:'磅及盎司',
      desc:'有效范围： 11oz - 881 lb 14 oz',
      scale:1,
      min:1,
      max:882,
    }, */
  ],
  'weight.bodyweight.kg': [
    {
      key: 'kg',
      zhName: '千克',
      desc: '有效范围： 0.3 - 400 kg',
      scale: 1,
      min: 0.3,
      max: 400,
      title: '体重'
    }
  ],
  'weight.bodyweight.kg.body': [
    {
      key: 'kg',
      zhName: '千克',
      desc: '有效范围： 0 - 300 kg',
      scale: 1,
      min: 0,
      max: 300,
      title: '体重'
    }
  ],
  'weight.bodyweight.kg.child': [
    {
      key: 'kg',
      zhName: '千克',
      desc: '有效范围： 0 - 100 kg',
      scale: 1,
      min: 0,
      max: 100,
      title: '体重'
    }
  ],
  'weight.bodyweight.kg.baby': [
    {
      key: 'kg',
      zhName: '千克',
      desc: '有效范围： 0 - 30 kg',
      scale: 1,
      min: 0,
      max: 30,
      title: '体重'
    }
  ],
  'weight.bodyweight.kg.burn': [
    {
      key: 'kg',
      zhName: '千克',
      desc: '有效范围： 0 - 300 kg',
      scale: 1,
      min: 0,
      max: 300,
      title: '体重'
    }
  ],
  /** 体重 */
  'weight.bodyweight.any': [
    {
      key: 'kg',
      zhName: '千克',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: '体重'
    }
  ],
  'height.height': [
    {
      key: 'cm',
      zhName: '厘米',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: '身高'
    }
  ],
  'age.common': [
    {
      key: '岁',
      zhName: '岁',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: '年龄'
    }
  ],
  'height.bodyweight': [
    {
      key: 'm',
      zhName: '米',
      desc: '有效范围： 0.1 - 2.5 m',
      scale: 1,
      min: 0.1,
      max: 2.5,
      title: '身高'
    },
    {
      key: 'cm',
      zhName: '厘米',
      desc: '有效范围： 10 - 250 cm',
      scale: 100,
      min: 10,
      max: 250,
      title: '身高'
    }
  ],
  'height.baby': [
    {
      key: 'cm',
      zhName: '厘米',
      desc: '有效范围： 10 - 150 cm',
      scale: 1,
      min: 10,
      max: 150,
      title: '身高'
    }
  ],
  'head.circumference.baby': [
    {
      key: 'cm',
      zhName: '厘米',
      desc: '有效范围： 10 - 70 cm',
      scale: 1,
      min: 10,
      max: 70,
      title: '头围'
    }
  ],
  /** 体温 */
  'temperature': [
    {
      key: '℃',
      zhName: '摄氏',
      desc: '有效范围： 15 - 47 ℃',
      scale: 1,
      min: 15,
      max: 47

    },
    {
      key: '℉',
      zhName: '摄氏',
      desc: '有效范围： 59 - 116.6 ℉',
      scale: 1.8,
      min: 59,
      max: 116.6,
      baseNum: 32
    }
  ],
  /** 呼吸频率 */
  'respiratoryrate': [
    {
      key: 'min <sup>-1</sup>',
      zhName: '呼吸每分钟',
      desc: '有效范围： 5 - 60 min <sup>-1</sup>',
      scale: 1,
      min: 5,
      max: 60
    }
  ],
  /** 心率 */
  'heartrate': [
    {
      key: 'bpm',
      zhName: '博每分钟',
      desc: '正常范围： 60 - 100 bpm <br>有效范围： 10 - 300 bpm',
      scale: 1,
      min: 10,
      max: 300
    }
  ],
  'pressure.blood.map': [
    {
      key: 'mmHg',
      zhName: '毫米汞柱',
      desc: '正常范围： 70 - 105 mmHg <br>有效范围： 10 - 300 mmHg',
      scale: 1,
      min: 10,
      max: 300
    }
  ],
  'co': [
    {
      key: 'L/min',
      zhName: '每分钟升',
      desc: '有效范围： 0.5 - 30 L/min',
      scale: 1,
      min: 0,
      max: 100
    }
  ],
  // IDUV
  'iduv': [
    {
      key: 'ml',
      desc: '有效范围： 0 ~ 1000ml',
      scale: 1,
      min: 0,
      max: 1000
    }
  ],
  // uuc
  'uuc': [
    {
      key: 'mmol/L',
      desc: '有效范围： 0 ~ 10000mmol/L',
      scale: 1,
      min: 0,
      max: 10000
    },
    {
      key: 'mg/dl',
      desc: '有效范围： 0 ~ 180300mg/dl',
      scale: 18.03,
      min: 0,
      max: 180300
    }

  ],
  // idp
  'idp': [
    {
      key: 'min',
      desc: '有效范围： 0 ~ 999999min',
      scale: 1,
      min: 0,
      max: 999999
    }
  ],
  // bun
  'buna': [
    {
      key: 'mmol/L',
      desc: '有效范围： 0 ~ 10000mmol/L',
      scale: 1,
      min: 0,
      max: 10000
    },
    {
      key: 'mg/dl',
      desc: '有效范围： 0 ~ 180300mg/dl',
      scale: 18.03,
      min: 0,
      max: 180300
    }
  ],
  // 血容
  'hct': [
    {
      desc: '有效范围： 0 ~ 1',
      scale: 1,
      min: 0,
      max: 1
    }
  ],
  // 血细胞比容
  'hct.copy': [
    {
      key: '%',
      desc: '有效范围： 0 ~ 100',
      scale: 1,
      min: 0,
      max: 100
    }
  ],
  // μmol/L
  'xqjg': [

    {
      key: 'μmol/L',
      desc: '有效范围： 10-3000 μmol/L',
      scale: 88.4,
      min: 10,
      max: 3000
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 0.11-33.9mg/dL',
      scale: 1,
      min: 0.11,
      max: 33.9
    }
  ],
  // ast alt
  'xq': [
    {
      key: 'U/L',
      desc: '有效范围：0~10000 U/L',
      scale: 1,
      min: 0,
      max: 10000
    }
  ],
  // 血小板计数
  'xxb': [
    {
      key: '10^9/L',
      desc: '有效范围：0~10000*10^9/L',
      scale: 1,
      min: 0,
      max: 10000
    }
  ],
  // fsbdb
  'fs': [
    {
      key: 'g/dL',
      scale: 1,
      min: 0,
      max: 99999
    },
    {
      key: 'g/L',
      scale: 10,
      min: 0,
      max: 99999
    }

  ],
  // sao2
  'sao2': [
    {
      key: '%',
      desc: '有效范围： 0~100 %',
      scale: 1,
      min: 0,
      max: 100
    }
  ],
  // hb
  'hb': [
    {
      key: 'g/L',
      desc: '有效范围： 0~999 g/L',
      scale: 1,
      min: 0,
      max: 999
    }
  ],
  'ps': [
    {
      key: 'mmol/L',
      desc: '有效范围： 0-20mmol/L',
      scale: 1,
      min: 0,
      max: 9999
    }
  ],
  'ps_three': [
    {
      key: 'mmol/L',
      desc: '有效范围： ＜4mmol/L',
      scale: 1,
      min: 0,
      max: 9999
    }
  ],
  'unit_talk_people': [
    {
      key: '小格',
      desc: '有效范围： 1~750格',
      scale: 1,
      min: 0,
      max: 30
    },
    {
      key: 's',
      desc: '有效范围： 0~30s',
      scale: 25,
      min: 0,
      max: 30
    }

  ],
  // 心脏
  'xz': [
    {
      key: 'ml',
      desc: '有效范围： 0~500 ml',
      scale: 1,
      min: 0,
      max: 500
    }
  ],
  // 血清钙浓度
  'ca': [
    {
      key: 'mmol/L',
      desc: '有效范围： 0~5000 mmol/L',
      scale: 1,
      min: 0,
      max: 5000
    }
  ],
  // 蛋白z
  'dbz': [
    {
      key: 'g/L',
      desc: '有效范围： ≤1500 g/L',
      scale: 1,
      min: 0,
      max: 1500
    }
  ],
  // 蛋白
  'db': [
    {
      key: 'g/L',
      desc: '有效范围： ≤1000 g/L',
      scale: 1,
      min: 0,
      max: 1000
    },
    {
      key: 'g/dL',
      desc: '有效范围： ≤100 g/dL',
      scale: 10,
      min: 0,
      max: 100
    }
  ],
  // he4
  'he4': [
    {
      key: 'pmol/L',
      desc: '有效范围： ≤99999 pmol/L',
      scale: 1,
      min: 0,
      max: 99999
    }
  ],
  // ca125
  'ca125': [
    {
      key: 'U/ml',
      desc: '有效范围： ≤99999 U/ml',
      scale: 1,
      min: 0,
      max: 99999
    }
  ],
  // ca125
  'ca125_copy': [
    {
      key: 'U/ml',
      desc: '正常范围： 0 - 35 U/ml <br>有效范围： 0 - 9999 U/ml',
      scale: 1,
      min: 0,
      max: 9999
    }
  ],
  'vr': [
    {
      key: 'mmHg',
      zhName: '毫米汞柱',
      desc: '有效范围： 0 - 100 mmHg',
      scale: 1,
      min: 10,
      max: 300
    }
  ],
  'gcs.points': [
    {
      key: '分',
      zhName: '分',
      desc: '正常范围：15 分 <br>有效范围： 3 - 15 分',
      scale: 1,
      min: 3,
      max: 15
    }
  ],
  /** 血钾 */
  'potassium.serum': [
    {
      key: 'mEq/L',
      zhName: '毫当量每升',
      desc: '正常范围： 3.5 - 5 mEq/L <br>有效范围： 0.5 - 10 mg/L',
      scale: 1,
      min: 0.5,
      max: 10
    },
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '正常范围： 3.5 - 5 mmol/L <br>有效范围： 0.5 - 10 mmol/L',
      scale: 1,
      min: 0.5,
      max: 10
    }
  ],
  urineNa: [ {
    key: 'mmol/L',
    zhName: '毫摩尔每升',
    desc: '有效范围： 0 - 300',
    scale: 1,
    min: 0,
    max: 300
  }],
  /** IFCC */
  IFCC: [
    {
      key: 'mmol/moL',
      zhName: '毫摩尔每摩尔',
      desc: '有效范围： 0 - 150',
      scale: 1,
      min: 0,
      max: 150
    }
  ],
  /** DCCT */
  DCCT: [
    {
      key: '%',
      zhName: '百分比',
      desc: '有效范围： 0 - 16',
      scale: 1,
      min: 0,
      max: 16
    }
  ],
  /** 平均血糖 */
  ADAG: [
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '有效范围： 0 - 23',
      scale: 1,
      min: 0,
      max: 23
    }
  ],
  ADAG1: [ {
    key: 'mg/dL',
    zhName: '毫克每分升',
    desc: '有效范围： 0 - 414',
    scale: 18,
    min: 0,
    max: 414
  }],
  /** 钾 */
  kalium: [
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '有效范围： 0 - 100 mmol/L',
      scale: 1,
      min: 0,
      max: 100
    }
  ],
  /** 碳酸氢盐 */
  'base.bicarbonate': [
    {
      key: 'mEq/L',
      zhName: '毫当量每升',
      desc: '正常范围： 21 - 30 mEq/L <br>有效范围： 0.1 - 99 mg/L',
      scale: 1,
      min: 0.1,
      max: 99
    },
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '正常范围： 21 - 30 mmol/L <br>有效范围： 0.1 - 99 mmol/L',
      scale: 1,
      min: 0.1,
      max: 99
    }
  ],
  /** ph */
  'bloodph': [
    {
      key: '',
      zhName: 'pH',
      desc: '正常范围： 7.25 - 7.45 <br>有效范围： 6.5 - 7.9',
      scale: 1,
      min: 6.5,
      max: 7.9
    }
  ],
  /** PaO₂ */
  'pressure.bloodgas.pao2': [
    {
      key: 'mmHg',
      zhName: '毫米汞柱',
      desc: '正常范围： 80 - 100 mmHg <br>有效范围： 1 - 760 mmHg',
      scale: 1,
      min: 1,
      max: 760
    },
    {
      key: 'kPa',
      zhName: '千帕',
      desc: '正常范围： 10.7 - 13.3 kPa <br>有效范围： 0.1 - 101.3 kPa',
      scale: 0.13328,
      min: 0.1,
      max: 101.3
    }
  ],
  pao2: [ {
    key: 'mmHg',
    zhName: '毫米汞柱',
    desc: '有效范围： 0 - 700 mmHg',
    scale: 1,
    min: 0,
    max: 700
  } ],
  /** 肺泡 - 动脉氧梯度 */
  'pressure.bloodgas.aagradient': [
    {
      key: 'mmHg',
      zhName: '毫米汞柱',
      desc: '正常范围： 0 - 10 mmHg <br>有效范围： -100 - 760 mmHg',
      scale: 1,
      min: -100,
      max: 760
    },
    {
      key: 'kPa',
      zhName: '千帕',
      desc: '正常范围： 0 - 1.3 kPa <br>有效范围： -13.3 - 101.3 kPa',
      scale: 0.13328,
      min: -13.3,
      max: 101.3
    }
  ],
  /** 收缩压 */
  'pressure.blood.systole': [
    {
      key: 'mmHg',
      zhName: '毫米汞柱',
      desc: '正常范围： 90 - 140 mmHg <br>有效范围： 10 - 300 mmHg',
      scale: 1,
      min: 10,
      max: 300
    }
  ],
  /** 舒张压 */
  'pressure.blood.diastole': [
    {
      key: 'mmHg',
      zhName: '毫米汞柱',
      desc: '正常范围： 60 - 90 mmHg <br>有效范围： 10 - 300 mmHg',
      scale: 1,
      min: 10,
      max: 300
    }
  ],
  'SV': [
    {
      key: 'ml',
      zhName: '每搏输出量',
      desc: '有效范围：0~999 ml',
      scale: 1,
      min: 0,
      max: 999
    }
  ],
  'EDV': [
    {
      key: 'ml',
      zhName: '心室舒张末期容积',
      desc: '有效范围：0~999 ml',
      scale: 1,
      min: 0,
      max: 999
    }
  ],
  'QT': [
    {
      key: 'ms',
      desc: '有效范围：40~30000ms',
      scale: 1000,
      min: 40,
      max: 30000
    },
    {
      key: 's',
      desc: '有效范围：0.04~30s',
      scale: 1,
      min: 0.04,
      max: 30
    }
  ],
  'RR': [
    {
      key: 'ms',
      desc: '有效范围：40~30000ms',
      scale: 1000,
      min: 40,
      max: 30000
    },
    {
      key: 's',
      desc: '有效范围：0.04~30s',
      scale: 1,
      min: 0.04,
      max: 30
    }
  ],
  /** 肌酐清除率 */
  'clearance.milliliter/min': [
    {
      key: 'mL/min',
      zhName: '毫升每分',
      desc: '有效范围： 1 - 250 mL/min',
      scale: 1,
      min: 1,
      max: 250
    }
  ],
  /** FiO₂ */
  'fraction.fio2.percent': [
    {
      key: '%',
      zhName: '百分比',
      desc: '有效范围： 21 - 100 %',
      scale: 1,
      min: 21,
      max: 100
    }
  ],
  /** 分数 */
  'fraction.percent': [
    {
      key: '%',
      zhName: '百分比',
      desc: '有效范围： 0 - 100 %',
      scale: 1,
      min: 0,
      max: 100
    }
  ],
  // 平均气道压
  map: [ {
    key: 'cmH2O',
    zhName: '厘米水',
    desc: '有效范围： 0 - 75',
    scale: 1,
    min: 0,
    max: 75
  }],
  fio2: [ {
    key: '%',
    zhName: '百分比',
    desc: '有效范围： 10 - 100 %',
    scale: 1,
    min: 10,
    max: 100
  }],
  /** 时间段 */
  'periodoftime.hour': [
    {
      key: 'h',
      zhName: '小时',
      desc: '有效范围： ≤ 7 h',
      scale: 1,
      min: 0,
      max: 7
    }
  ],
  'burn.hour': [
    {
      key: 'h',
      zhName: '小时',
      desc: '有效范围： ≤ 24 h',
      scale: 1,
      min: 0,
      max: 24
    }
  ],
  /** 时间段-336 */
  'periodoftime.hour336': [
    {
      key: 'h',
      zhName: '小时',
      desc: '有效范围： ≤ 336 h',
      scale: 1,
      min: 0,
      max: 336
    }
  ],
  /** 体积 */
  'volume.milliliter,liter': [
    {
      key: 'mL',
      zhName: '毫升',
      desc: '有效范围： ≤ 99999 mL',
      scale: 1000,
      min: 0,
      max: 99999
    },
    {
      key: 'L',
      zhName: '升',
      desc: '有效范围： ≤ 100 L',
      scale: 1,
      min: 0,
      max: 100
    }
  ],
  /** 肌酐 - 血肌酐-- 男 */
  'bloodoxygen': [
    {
      key: 'ml/dL',
      // zhName: '毫克每分升',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0
    }
  ],
  /** 肌酐 - 血肌酐-- 男 */
  'creatinine.serum.male': [
    {
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '正常范围： 0.9 - 1.3 mg/dL <br>有效范围： 0.1 - 56.6 mg/dL',
      scale: 1,
      min: 0.1,
      max: 56.6
    },
    {
      key: 'mg/L',
      zhName: '毫克每升',
      desc: '正常范围： 9 - 13 mg/L <br>有效范围： 1 - 566 mg/L',
      scale: 10,
      min: 1,
      max: 566
    },
    {
      key: 'umol/L',
      zhName: '微摩尔每升',
      desc: '正常范围： 80 - 115 umol/L <br>有效范围： 10 - 5000 umol/L',
      scale: 88.417,
      min: 10,
      max: 5000
    }
  ],
  /** 肌酐 - 血肌酐-- 女 */
  'creatinine.serum.female': [
    {
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '正常范围： 0.6 - 1.1 mg/dL <br>有效范围： 0.1 - 56.6 mg/dL',
      scale: 1,
      min: 0.1,
      max: 56.6
    },
    {
      key: 'mg/L',
      zhName: '毫克每升',
      desc: '正常范围： 6 - 11 mg/L <br>有效范围： 1 - 566 mg/L',
      scale: 10,
      min: 1,
      max: 566
    },
    {
      key: 'umol/L',
      zhName: '微摩尔每升',
      desc: '正常范围： 53 - 97 umol/L <br>有效范围： 10 - 5000 umol/L',
      scale: 88.417,
      min: 10,
      max: 5000
    }
  ],
  /** 肌酐 - 血肌酐-- 男 */
  'creatinine.serum.male.copy': [
    {
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '有效范围： 0.1 - 56.6 mg/dL',
      scale: 1,
      min: 0.1,
      max: 56.6
    },
    {
      key: 'mg/L',
      zhName: '毫克每升',
      desc: '有效范围： 1 - 566 mg/L',
      scale: 10,
      min: 1,
      max: 566
    },
    {
      key: 'umol/L',
      zhName: '微摩尔每升',
      desc: '有效范围： 10 - 5000 umol/L',
      scale: 88.417,
      min: 10,
      max: 5000
    }
  ],
  /** 肌酐 - 血肌酐-- 女 */
  'creatinine.serum.female.copy': [
    {
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '有效范围： 0.1 - 56.6 mg/dL',
      scale: 1,
      min: 0.1,
      max: 56.6
    },
    {
      key: 'mg/L',
      zhName: '毫克每升',
      desc: '有效范围： 1 - 566 mg/L',
      scale: 10,
      min: 1,
      max: 566
    },
    {
      key: 'umol/L',
      zhName: '微摩尔每升',
      desc: '有效范围： 10 - 5000 umol/L',
      scale: 88.417,
      min: 10,
      max: 5000
    }
  ],
  // 血钠浓度
  'blood.sodium.concentration': [
    {
      key: 'mmol/L',
      desc: '有效范围： 0 - 1000 mmol/L',
      scale: 1,
      min: 0,
      max: 1000
    }
  ],
  /* 血钠 */
  'blood.sodium': [
    {
      key: 'mmol/L',
      desc: '有效范围： 30 - 190 mmol/L',
      scale: 1,
      min: 30,
      max: 190
    }
  ],
  'fev.fvc': [
    {
      key: 'ml',
      desc: '有效范围： 0 - 3000 mL',
      scale: 1,
      min: 0,
      max: 3000
    }
  ],
  /** PaCO₂  */
  'pressure.bloodgas.paco2': [
    {
      key: 'mmHg',
      zhName: '毫米汞柱',
      desc: '正常范围： 35 - 45 mmHg <br>有效范围： 1 - 760 mmHg',
      scale: 1,
      min: 1,
      max: 760
    },
    {
      key: 'kPa',
      zhName: '千帕',
      desc: '正常范围： 4.7 - 6 kPa <br>有效范围： 0.1 - 101.3 kPa',
      scale: 0.13328,
      min: 0.1,
      max: 101.3
    }
  ],
  /** 压力 （大气）  */
  'pressure.atmosphere': [
    {
      key: 'mmHg',
      zhName: '毫米汞柱',
      desc: '有效范围： 1 - 760 mmHg',
      scale: 1,
      min: 1,
      max: 760
    },
    {
      key: 'kPa',
      zhName: '千帕',
      desc: '有效范围： 0.1 - 101.3 kPa',
      scale: 0.13328,
      min: 0.1,
      max: 101.3
    },
    {
      key: 'atm',
      zhName: 'atmosphere',
      desc: '有效范围： 0 - 1 atm',
      scale: 1,
      min: 0,
      max: 1
    },
    {
      key: 'bar',
      zhName: 'bar',
      desc: '有效范围： 0 - 1 bar',
      scale: 0.13328,
      min: 0,
      max: 1
    }
  ],
  /** 厘米 */
  'length.centimeter': [
    {
      key: 'cm',
      zhName: '厘米',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0
    }
  ],
  /** 体表面积 */
  'bodysurfacearea': [
    {
      key: '㎡',
      zhName: '平方米',
      desc: '有效范围： 0.1 - 4 ㎡',
      scale: 1,
      min: 0.1,
      max: 4
    }
  ],
  /** 体表面积 */
  'bodysurfacearea.copy': [
    {
      key: '㎡',
      zhName: '平方米',
      desc: '有效范围： 1 - 3 ㎡',
      scale: 1,
      min: 1,
      max: 3
    }
  ],
  'body.surface.area': [
    {
      key: '㎡',
      zhName: '平方米',
      desc: '有效范围： 0 - 4 ㎡',
      scale: 1,
      min: 0,
      max: 4
    }
  ],
  'body.surface.area.child': [
    {
      key: '㎡',
      zhName: '平方米',
      desc: '有效范围： 0.1 - 2 ㎡',
      scale: 1,
      min: 0.1,
      max: 2
    }
  ],
  /** 心输出量 */
  'cardiacoutput': [
    {
      key: 'L/min',
      zhName: '升每分钟',
      desc: '正常范围： 4 - 5 L/min <br>有效范围： 0.5 - 30 L/min',
      scale: 1,
      min: 0.5,
      max: 30
    }
  ],
  /** 充盈期 */
  'fillingperiod': [
    {
      key: 's/心博',
      zhName: '升每分钟',
      desc: '有效范围： ≤ 9.99 s/心博',
      scale: 1,
      min: 0,
      max: 9.99
    }
  ],
  /** 血压 */
  'pressure.blood.meanvalvegradient': [
    {
      key: 'mmHg',
      zhName: '毫米汞柱',
      desc: '有效范围： 0 - 150 mmHg',
      scale: 1,
      min: 0,
      max: 150
    }
  ],
  /** */
  'auc.milligram/milliliter/minute': [
    {
      key: 'mg/mL/min',
      zhName: '',
      desc: '有效范围： 5 - 10 mg/mL/min',
      scale: 1,
      min: 5,
      max: 10
    }
  ],
  /** 压力  */
  'pressure.bloodgas': [
    {
      key: 'mmHg',
      zhName: '毫米汞柱',
      desc: '有效范围： 1 - 760 mmHg',
      scale: 1,
      min: 1,
      max: 760
    },
    {
      key: 'kPa',
      zhName: '千帕',
      desc: '有效范围： 0.1 - 101.3 kPa',
      scale: 0.13328,
      min: 0.1,
      max: 101.3
    }
  ],
  // 氯
  'CL': [ {
    title: '氯',
    key: 'mmol/L',
    zhName: '毫摩尔每升',
    desc: '有效范围：0-1000 mmol/L',
    scale: 1,
    min: 0,
    max: 1000
  }],
  // 血清铁
  'iron.serum': [ {
    title: '血清铁',
    key: 'umol/L',
    zhName: '微摩尔每升',
    desc: '有效范围：0-10000 mmol/L',
    scale: 1,
    min: 0,
    max: 10000
  }],
  // 总铁结合力
  'iron.total': [ {
    title: '总铁结合力',
    key: 'umol/L',
    zhName: '微摩尔每升',
    desc: '有效范围：0-10000 mmol/L',
    scale: 1,
    min: 0,
    max: 10000
  }],
  /** x血白蛋白 */
  'albumin.serum': [
    {
      key: 'g/dL',
      zhName: '克每分升',
      desc: '正常范围：3.5 - 5.5 g/dL <br>有效范围： 0.5 - 10 g/dL',
      scale: 1,
      min: 0.5,
      max: 10
    },
    {
      key: 'g/L',
      zhName: '克每升',
      desc: '正常范围： 35 - 55 g/L <br>有效范围： 5 - 100 g/L',
      scale: 10,
      min: 5,
      max: 100
    }
  ],
  /** 白蛋白 */
  'albumin.serum.copy': [
    {
      key: 'g/dL',
      zhName: '克每分升',
      desc: '正常范围：3.5 - 5.5 g/dL <br>有效范围： 0.5 - 10 g/dL',
      scale: 1,
      min: 0.5,
      max: 10
    },
    {
      key: 'g/L',
      zhName: '克每升',
      desc: '正常范围： 35 - 55 g/L <br>有效范围： 0 - 100 g/L',
      scale: 10,
      min: 0,
      max: 100
    }
  ],
  /** 凝血酶原时间 */
  'sec': [{
    key: 's',
    zhName: '秒',
    desc: '正常范围： 11s-13s <br>有效范围： 0 - 200s',
    scale: 1,
    min: 0,
    max: 200
  }],
  /** 胆红素 */
  'bilirubin': [
    {
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '正常范围： 0.3 - 1 mg/dL <br>有效范围： 0.1 - 50 mg/dL',
      scale: 1,
      min: 0.1,
      max: 50
    },
    {
      key: 'mg/L',
      zhName: '毫克每升',
      desc: '正常范围： 3 - 10 mg/L <br>有效范围： 1 - 500 mg/L',
      scale: 10,
      min: 1,
      max: 500
    },
    {
      key: 'umol/L',
      zhName: '微摩尔每升',
      desc: '正常范围： 5 - 17 umol/L <br>有效范围： 1 - 855 umol/L',
      scale: 88.417,
      min: 1,
      max: 855
    }
  ],
  /** 胆红素 */
  'bilirubin.copy': [
    {
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '正常范围： 0.3 - 1 mg/dL <br>有效范围： 0.1 - 50 mg/dL',
      scale: 1,
      min: 0.1,
      max: 50
    },
    {
      key: 'umol/L',
      zhName: '微摩尔每升',
      desc: '正常范围： 5 - 17 umol/L <br>有效范围： 1 - 855 umol/L',
      scale: 88.417,
      min: 1,
      max: 855
    }
  ],
  /** 凝血酶原时间 */
  'prothrombin.percent': [{
    key: '%',
    zhName: '百分比',
    desc: '有效范围： 任何数值',
    scale: 1
  }],
  /** 国际标准化率 */
  'inr': [{
    key: '',
    zhName: '',
    desc: '正常范围： 0.8 - 1.3 <br>有效范围： 0.1 - 20',
    scale: 1,
    min: 0.1,
    max: 20
  }],
  /** 天冬氨酸氨基转移酶 */
  'ast.serum': [{
    key: 'U/L',
    zhName: '酶单位每升',
    desc: '正常范围： 10 - 40 U/L <br>有效范围： 0 - 15000 U/L',
    scale: 1,
    min: 0,
    max: 15000
  }],
  /** 丙氨酸氨基转移酶 */
  'alt.serum': [{
    key: 'U/L',
    zhName: '酶单位每升',
    desc: '正常范围： 8 - 36 U/L <br>有效范围： 0 - 1000 U/L',
    scale: 1,
    min: 0,
    max: 1000
  }],
  /** 乳酸脱氢酶 */
  'ldh.serum': [{
    key: 'U/L',
    zhName: '酶单位每升',
    desc: '正常范围： 100 - 300 U/L <br>有效范围： 0 - 5000 U/L',
    scale: 1,
    min: 0,
    max: 5000
  }],
  /** 脂酶 */
  'lipase.serum': [{
    key: 'U/L',
    zhName: '酶单位每升',
    desc: '正常范围： 10 - 73 U/L <br>有效范围： 0 - 1000 U/L',
    scale: 1,
    min: 0,
    max: 1000
  }],
  /** 身高 */
  'length.bodyheight': [
    {
      key: 'm',
      zhName: '米',
      desc: '有效范围： 0.1 - 2.5 m',
      scale: 1,
      min: 0.1,
      max: 2.5
    },
    {
      key: 'cm',
      zhName: '厘米',
      desc: '有效范围： 10 - 250 cm',
      scale: 100,
      min: 10,
      max: 250
    }
  ],
  /** 身高 （母亲） */
  'length.bodyheight.adult.mother': [
    {
      key: 'm',
      zhName: '米',
      desc: '有效范围： 1.2 - 2.5 m',
      scale: 1,
      min: 1.2,
      max: 2.5
    },
    {
      key: 'cm',
      zhName: '厘米',
      desc: '有效范围： 120 - 250 cm',
      scale: 100,
      min: 120,
      max: 250
    }
  ],
  /** 身高 （父亲） */
  'length.bodyheight.adult.father': [
    {
      key: 'm',
      zhName: '米',
      desc: '有效范围： 1.2 - 2.5 m',
      scale: 1,
      min: 1.2,
      max: 2.5
    },
    {
      key: 'cm',
      zhName: '厘米',
      desc: '有效范围： 120 - 250 cm',
      scale: 100,
      min: 120,
      max: 250
    }
  ],
  /** 身高 */
  'length.bodyheight.adult': [
    {
      key: 'm',
      zhName: '米',
      desc: '有效范围： 1.2 - 2.5 m',
      scale: 1,
      min: 1.2,
      max: 2.5,
      title: '身高'
    },
    {
      key: 'cm',
      zhName: '厘米',
      desc: '有效范围： 120 - 250 cm',
      scale: 100,
      min: 120,
      max: 250,
      title: '身高'
    }
  ],
  'length.bodyheight.cvc': [
    {
      key: 'cm',
      zhName: '厘米',
      desc: '有效范围： 10 - 250 cm',
      scale: 1,
      min: 10,
      max: 250,
      title: '身高'
    }
  ],
  /** 身高 */
  'length.body.height': [
    {
      key: 'm',
      zhName: '米',
      desc: '有效范围： 0.1 - 2.5 m',
      scale: 1,
      min: 0.1,
      max: 2.5
    },
    {
      key: 'cm',
      zhName: '厘米',
      desc: '有效范围： 10 - 250 cm',
      scale: 100,
      min: 10,
      max: 250
    },
    {
      key: 'in',
      zhName: '英寸',
      desc: '有效范围： 3.94 - 98.43 in',
      scale: 39.37,
      min: 3.94,
      max: 98.43
    }
  ],
  /** 钙 */
  'calcium.urine': [
    {
      title: '钙',
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '有效范围：任何数值',
      scale: 1,
      min: 0
    },
    {
      title: '钙',
      key: 'mg/L',
      zhName: '毫克每升',
      desc: '有效范围：任何数值',
      scale: 10,
      min: 0
    },
    {
      title: '钙',
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '有效范围：任何数值',
      scale: 0.2495,
      min: 0
    },
    {
      title: '钙',
      key: 'mEq/L',
      zhName: '毫当量每升',
      desc: '有效范围：任何数值',
      scale: 0.499,
      min: 0
    }
  ],
  /** 钙 */
  'calcium.urine.copy': [
    {
      title: '钙',
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '有效范围：任何数值',
      scale: 1,
      min: 0
    }

  ],
  /** 尿肌酐 */
  'creatinine.urine': [
    {
      title: '尿肌酐',
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '有效范围：≤ 1131.2 mg/dL',
      scale: 1,
      min: 0,
      max: 1131.2
    },
    {
      title: '尿肌酐',
      key: 'mg/L',
      zhName: '毫克每升',
      desc: '有效范围：≤ 11312 mg/L',
      scale: 10,
      min: 0,
      max: 11312
    },
    {
      title: '尿肌酐',
      key: 'umol/L',
      zhName: '微摩尔每升',
      desc: '有效范围：≤ 99999 umol/L',
      scale: 88.417,
      min: 0,
      max: 99999
    },
    {
      title: '尿肌酐',
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '有效范围：≤ 99.999 mmol/L',
      scale: 0.088417,
      min: 0,
      max: 99.999
    }
  ],
  'creatinine.urine.copy': [
    {
      title: '尿肌酐',
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '有效范围：≤ 1131.2 mg/dL',
      scale: 1,
      min: 0,
      max: 1131.2
    }
  ],
  /** 尿肌酐 */
  'urinary.creatinine': [
    {
      title: '尿肌酐',
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '有效范围：≤ 1131.2 mg/dL',
      scale: 1,
      min: 0,
      max: 1131.2
    },
    {
      title: '尿肌酐',
      key: 'umol/L',
      zhName: '微摩尔每升',
      desc: '有效范围：≤ 99999 umol/L',
      scale: 88.417,
      min: 0,
      max: 99999
    }
  ],
  /** 尿肌酐 */
  'creatinine.urine2': [
    {
      key: 'g/dL',
      zhName: '克每分升',
      desc: '有效范围：≤11.3 g/dL',
      scale: 0.0113,
      min: 0,
      max: 11.3,
      title: '尿肌酐'
    },
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '有效范围： ≤100 mmol/L',
      scale: 1,
      min: 0,
      max: 100,
      title: '尿肌酐'
    }
  ],
  /** 尿肌酐 */
  'creatinine.urine3': [
    {
      title: '尿肌酐',
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '有效范围：≤ 1131.2 mg/dL',
      scale: 1,
      min: 0,
      max: 1131.2
    },
    {
      title: '尿肌酐',
      key: 'mg/L',
      zhName: '毫克每升',
      desc: '有效范围：≤ 11312 mg/L',
      scale: 10,
      min: 0,
      max: 11312
    },
    {
      title: '尿肌酐',
      key: 'umol/L',
      zhName: '微摩尔每升',
      desc: '有效范围：≤ 99999 umol/L',
      scale: 88.417,
      min: 0,
      max: 99999
    }
  ],
  /** 体积 */
  'volume.urine': [
    {
      key: 'L',
      zhName: '升',
      desc: '有效范围： ≤ 99 L',
      scale: 1,
      min: 0,
      max: 99,
      title: '体积'
    },
    {
      key: 'dL',
      zhName: '分升',
      desc: '有效范围： ≤ 990 dL',
      scale: 10,
      min: 0,
      max: 990,
      title: '体积'
    },
    {
      key: 'mL',
      zhName: '毫升',
      desc: '有效范围： ≤ 99000 mL',
      scale: 1000,
      min: 0,
      max: 99000,
      title: '体积'
    }
  ],
  /** 时间段 */
  'periodoftime.urine': [
    {
      key: 'h',
      zhName: '小时',
      desc: '有效范围： ≤ 24 h',
      scale: 1,
      min: 0,
      max: 24,
      title: '时间段'
    },
    {
      key: 'min',
      zhName: '分钟',
      desc: '有效范围： ≤ 1440 min',
      scale: 60,
      min: 0,
      max: 1440,
      title: '时间段'
    }
  ],
  /** 年龄 */
  'age.pediatric': [
    {
      key: '岁',
      zhName: '岁',
      desc: '有效范围： 1 - 16 岁',
      scale: 1,
      min: 1,
      max: 16,
      title: '年龄'
    }
  ],
  /** 氧饱和度 - 主动脉 */
  'fraction.oxygen-saturation.arterial.percent': [
    {
      key: '%',
      zhName: '百分比',
      desc: '有效范围：  10 - 100 %',
      scale: 1,
      min: 10,
      max: 100,
      title: '氧饱和度'
    }
  ],
  /** 氧饱和度 - 混合静脉 */
  'fraction.oxygen-saturation.venous.percent': [
    {
      key: '%',
      zhName: '百分比',
      desc: '有效范围：  10 - 100 %',
      scale: 1,
      min: 10,
      max: 100,
      title: '氧饱和度'
    }
  ],
  /** 氧饱和度 - 肺静脉 */
  'fraction.oxygen-saturation.pulmonalvenous.percent': [
    {
      key: '%',
      zhName: '百分比',
      desc: '有效范围：  10 - 100 %',
      scale: 1,
      min: 10,
      max: 100,
      title: '氧饱和度'
    }
  ],
  /** 氧饱和度 - 肺动脉 */
  'fraction.oxygen-saturation.pulmonalarterial.percent': [
    {
      key: '%',
      zhName: '百分比',
      desc: '有效范围：  10 - 100 %',
      scale: 1,
      min: 10,
      max: 100,
      title: '氧饱和度'
    }
  ],
  /** 磷酸盐 */
  'phosphate': [
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '有效范围：任何数值',
      scale: 1,
      min: 0,
      title: '磷酸盐'
    },
    {
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '有效范围：任何数值',
      scale: 18.03,
      min: 0,
      title: '磷酸盐'
    },
    {
      key: 'mg/L',
      zhName: '毫克每升',
      desc: '有效范围：任何数值',
      scale: 180.3,
      min: 0,
      title: '磷酸盐'
    }
  ],
  /* 血清镁 */
  'serum.magnesium': [
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '有效范围：任何数值',
      scale: 1,
      min: 0,
      title: '血清镁'
    },
    {
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '有效范围：任何数值',
      scale: 18.03,
      min: 0,
      title: '血清镁'
    }
  ],
  /* 尿镁 */
  'magnesium.urine': [
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '有效范围：任何数值',
      scale: 1,
      min: 0,
      title: '血清镁'
    },
    {
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '有效范围：任何数值',
      scale: 18.03,
      min: 0,
      title: '血清镁'
    }
  ],
  /** 血红蛋白 */
  // 'hemoglobin.blood': [
  //   {
  //     key: 'g/dL',
  //     zhName: '克每分升',
  //     desc: '有效范围： 1 - 30 g/dL',
  //     scale: 10,
  //     min: 1,
  //     max: 30,
  //     title: '血红蛋白'
  //   },
  //   {
  //     key: 'g/L',
  //     zhName: '克每升',
  //     desc: '有效范围： 1 - 300 g/L',
  //     scale: 10,
  //     min: 1,
  //     max: 300,
  //     title: '血红蛋白'
  //   }
  //   /* { // 国权说不要
  //     key:'mmol/L',
  //     zhName:'毫摩尔每升',
  //     desc:'有效范围： 0.6 - 18.6 mmol/L',
  //     scale:1,
  //     min:0.6,
  //     max:18.6,
  //   }, */
  // ],
  /** 碱剩余 */
  'base.be': [
    {
      key: 'mEq/L',
      zhName: '毫当量每升',
      desc: '正常范围： -4 - 4 mEq/L <br>有效范围： -50 - 50 mg/L',
      scale: 1,
      min: -50,
      max: 50,
      title: '碱剩余'
    },
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '正常范围： -4 - 4 mmol/L <br>有效范围： -50 - 50 mmol/L',
      scale: 1,
      min: -50,
      max: 50,
      title: '碱剩余'
    }
  ],
  /** FEV1 */
  'fraction.fev1.percent': [
    {
      key: '%',
      zhName: '百分比',
      desc: '有效范围： 5 - 90 %',
      scale: 1,
      min: 5,
      max: 90,
      title: 'FEV<sub>1</sub>'
    }
  ],
  /** 体重指数 */
  'bmi': [
    {
      key: 'kg/㎡',
      zhName: '千克每平方米',
      desc: '有效范围： 5 - 150 kg/㎡',
      scale: 1,
      min: 5,
      max: 150,
      title: '体重指数'
    }
  ],
  /** 距离 */
  'distance.walking': [
    {
      key: 'm',
      zhName: '米',
      desc: '有效范围： 0 - 999 m',
      scale: 1,
      min: 0,
      max: 999,
      title: '距离'
    },
    {
      key: 'ft',
      zhName: '英尺',
      desc: '有效范围： 0 - 3278 ft',
      scale: 3.2808,
      min: 0,
      max: 3278,
      title: '距离'
    },
    {
      key: 'yard',
      zhName: 'yard',
      desc: '有效范围： 0 - 1093 yard',
      scale: 1.0936,
      min: 0,
      max: 1093,
      title: '距离'
    }

  ],
  /** 流 */
  'flow.liter/minute': [
    {
      key: 'L/min',
      zhName: '升每分钟',
      desc: '有效范围：≤ 100 L/min',
      scale: 1,
      min: 0,
      max: 100,
      title: '流'
    }
  ],
  'pef.liter/minute': [
    {
      key: 'L/min',
      zhName: '升每分钟',
      desc: '有效范围： 100 - 800 L/min',
      scale: 1,
      min: 100,
      max: 800,
      title: 'PEF值'
    }
  ],
  /** 年龄 */
  'age.pef': [
    {
      key: '岁',
      zhName: '岁',
      desc: '有效范围： 15 - 85 岁',
      scale: 1,
      min: 15,
      max: 85
    }
  ],
  /** 钢瓶压力 */
  'tankpressure': [
    {
      key: 'bar',
      zhName: 'bar',
      desc: '有效范围： ≤ 1000 bar',
      scale: 1,
      min: 0,
      max: 1000,
      title: '钢瓶压力'
    },
    {
      key: 'psi',
      zhName: 'pround per square inch',
      desc: '有效范围： ≤ 14504 psi',
      scale: 14.5038,
      min: 0,
      max: 1000,
      title: '钢瓶压力'
    }
  ],
  /** 钢瓶压力 */
  'tankpressure.pound per square inch': [
    {
      key: 'psi',
      zhName: 'pround per square inch',
      desc: '有效范围： ≤ 14504 psi',
      scale: 1,
      min: 0,
      max: 1000,
      title: '钢瓶压力'
    }
  ],
  /** 体积 */
  'volume.liter': [
    {
      key: 'L',
      zhName: '升',
      desc: '有效范围： ≤ 1000 L',
      scale: 0.001,
      min: 0,
      max: 1000,
      title: '体积'
    }
  ],

  /** 脑钠尿肽 */
  'bnp': [
    {
      key: 'ng/L',
      zhName: '纳克每升',
      desc: '有效范围：0 - 15000 ng/L',
      scale: 1,
      min: 0,
      max: 15000,
      title: '脑钠尿肽'

    }
  ],
  /** 长度 */
  'length.nodulediameter': [
    {
      key: 'cm',
      zhName: '厘米',
      desc: '有效范围：任何数值',
      scale: 1,
      min: 0,
      title: '长度'
    },
    {
      key: 'mm',
      zhName: '毫米',
      desc: '有效范围：任何数值',
      scale: 10,
      min: 0,
      title: '长度'
    }
  ],
  /** 高度 */
  'distance.altitude': [
    {
      key: 'm',
      zhName: '米',
      desc: '有效范围： 0 - 20000 m',
      scale: 1,
      min: 0,
      max: 20000,
      title: '高度'
    },
    {
      key: 'ft',
      zhName: '英尺',
      desc: '有效范围： 0 - 65617 ft',
      scale: 3.2808,
      min: 0,
      max: 65617,
      title: '高度'
    },
    {
      key: 'yd',
      zhName: 'yard',
      desc: '有效范围： 0 - 21872 yd',
      scale: 1.0936,
      min: 0,
      max: 21872,
      title: '高度'
    }
  ],
  /** 血浆渗透压 - Na+ */
  'plasma.osmotic.pressure.na': [
    {
      key: 'mEq/L',
      zhName: '[Na+]',
      desc: '',
      scale: 1,
      min: 0,
      max: 20000,
      title: '血浆渗透压'
    }
  ],
  /** 血浆渗透压 - 葡萄糖 */
  'plasma.osmotic.pressure.glucose': [
    {
      key: 'mg/dl',
      zhName: '葡萄糖',
      desc: '',
      scale: 1,
      min: 0,
      max: 20000,
      title: '血浆渗透压'
    }
  ],
  /** 血浆渗透压 - 血尿素氮 */
  'plasma.osmotic.pressure.bun': [
    {
      key: 'mg/dl',
      zhName: '血尿素氮',
      desc: '',
      scale: 1,
      min: 0,
      max: 20000,
      title: '血浆渗透压'
    }
  ],
  // Upr 尿蛋白
  'upr': [
    {
      key: 'g/L',
      zhName: '克每升',
      desc: '有效范围： 0.01~1500g/L',
      scale: 1,
      min: 0.01,
      max: 1500,
      title: '尿蛋白'
    }
  ],
  // Ucr 尿肌酐
  'ucr': [
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '有效范围： 0~100mmol/L',
      scale: 1,
      min: 0,
      max: 100,
      title: '尿肌酐'
    }
  ],
  /** 体表面积 */
  'albumen.bodysurfacearea': [
    {
      key: '㎡',
      zhName: '平方米',
      desc: '有效范围： 0 - 0.4 ㎡',
      scale: 1,
      min: 0,
      max: 0.4
    }
  ],
  // 高血糖时钠浓度
  'Hyperglycemia.concentration': [
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '有效范围： 90~190mmol/L',
      scale: 1,
      title: ''
    }
  ],
  'Hyperglycemia.concentration.k': [
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '有效范围： ≤9999mmol/L',
      scale: 1,
      title: ''
    }
  ],
  'Hyperglycemia.concentration.g': [
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '有效范围：0.1~160mmol/L',
      scale: 1,
      title: ''
    }
  ],
  'Hyperglycemia.concentration.b': [
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '有效范围：≤9999mmol/L',
      scale: 1,
      title: ''
    }
  ],
  'urine.Na': [
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '有效范围： 0~300mmol/L',
      scale: 1,
      min: 0,
      max: 300,
      title: '尿Na'
    }
  ],
  'urine.K': [
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '有效范围： 0~200mmol/L',
      scale: 1,
      min: 0,
      max: 200,
      title: '尿K'
    }
  ],
  'urine.Cl': [
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      desc: '正常范围： 110 - 250 mmol/L <br>有效范围： 0 - 300 mmol/L',
      scale: 1,
      min: 0,
      max: 300,
      title: '尿Cl'
    }
  ],
  // Ca(钙)
  'Ca': [
    {
      key: 'mmol/L',
      desc: '正常范围： 2.12 - 2.62 mmol/L <br>有效范围： 0.25 - 6.24 mmol/L',
      scale: 1,
      min: 0.25,
      max: 6.24
    },
    {
      key: 'mg/dl',
      desc: '正常范围： 8.5 - 10.5 mg/dl <br>有效范围： 1 - 25 mg/dl',
      scale: 18.03,
      min: 1,
      max: 25
    }

  ],
  // Pr(蛋白质)
  'Pr': [
    {
      key: 'g/L',
      desc: '正常范围： 60 - 78 g/L <br>有效范围： 5 - 300 g/L',
      scale: 1,
      min: 5,
      max: 300
    },
    {
      key: 'g/dL',
      desc: '正常范围： 6 - 7.8 mg/dl <br>有效范围： 0.5 - 30 mg/dl',
      scale: 10,
      min: 0.5,
      max: 30
    }
  ],
  // Alb(白蛋白)
  'Alb': [
    {
      key: 'g/dL',
      desc: '正常范围： 3.5 - 5.5 mg/dl <br>有效范围： 0.5 - 10 mg/dl',
      scale: 10,
      min: 0.5,
      max: 10
    },
    {
      key: 'g/L',
      desc: '正常范围： 35 - 55 g/L <br>有效范围： 5 - 100 g/L',
      scale: 1,
      min: 5,
      max: 100
    }
  ],
  // 尿Alb（尿白蛋白）
  'urinary.albumin': [
    {
      title: '尿白蛋白',
      key: 'mg/dL',
      zhName: '毫克每分升',
      desc: '有效范围： ≤25000mg/dL',
      scale: 1,
      min: 0,
      max: 25000
    },
    {
      title: '尿白蛋白',
      key: 'mg/L',
      zhName: '毫克每升',
      desc: '有效范围： ≤250000mg/L',
      scale: 10,
      min: 0,
      max: 25000
    }
  ],
  // 毫摩尔每升
  'mmol.L': [
    {
      key: 'mmol/L',
      zhName: '毫摩尔每升',
      scale: 1,
      title: ''
    }
  ],
  // 毫摩尔每克
  'mmol.kg': [
    {
      key: 'mmol/kg',
      zhName: '毫摩尔每克',
      scale: 1,
      title: ''
    }
  ],
  // 甲状腺左右叶长宽厚度
  'thyroid.length': [
    {
      key: 'mm',
      zhName: '毫米',
      desc: '有效范围：任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  // 7天水样便
  'watery.stool': [
    {
      key: '次',
      scale: 1,
      min: 0
    }
  ],
  // 剂量
  'dose': [
    {
      key: 'g',
      zhName: '克',
      desc: '有效范围：任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  // VO₂ VCO₂
  'vo₂.vco₂': [
    {
      key: 'ml',
      zhName: '毫升',
      desc: '有效范围：任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mol',
      zhName: '摩尔',
      desc: '有效范围：任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  // 心率
  'heart.rate': [
    {
      key: '次/min',
      zhName: '次每分钟',
      desc: '有效范围：任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'systolic.blood.pressure': [
    {
      key: 'mmHg',
      zhName: '毫米汞柱',
      desc: '有效范围：任何数值',
      scale: 1,
      min: 0
    }
  ],
  // 补液量
  'fluid.volume': [
    {
      key: 'ml',
      zhName: '毫升',
      desc: '有效范围：≤47000mmol/L',
      scale: 1,
      min: 0,
      max: 47000
    }
  ],
  // 补液量
  'fluid.volume.copy': [
    {
      key: 'ml',
      zhName: '毫升',
      desc: '有效范围：≤80000mmol/L',
      scale: 1,
      min: 0,
      max: 80000
    }
  ],
  // 能量单位
  'energy': [
    {
      key: 'kcal',
      zhName: '千卡',
      scale: 1
    },
    {
      key: 'cal',
      zhName: '卡',
      scale: 1000
    },
    {
      key: 'j',
      zhName: '焦耳',
      scale: 4184
    },
    {
      key: 'kj',
      zhName: '千焦',
      scale: 4.184
    },
    {
      key: 'MJ',
      zhName: '兆焦',
      scale: 0.004184
    }
  ],
  // 总胆固醇（TC）、高密度脂蛋白胆固醇（HDL-C）、低密度脂蛋白胆固醇（HDL-C）
  'tc_hdlc': [
    {
      key: 'mmol/L',
      zhName: '',
      scale: 1
    },
    {
      key: 'mg/dL',
      zhName: '',
      scale: 38.6
    }
  ],
  'tg': [
    {
      key: 'mmol/L',
      zhName: '',
      scale: 1
    },
    {
      key: 'mg/dL',
      zhName: '',
      scale: 88.5
    }
  ],
  // 激素剂量单位
  'hormone.dose': [
    {
      key: '可的松',
      scale: 25
    },
    {
      key: '氢化可的松',
      scale: 20
    },
    {
      key: '泼尼松',
      scale: 5
    },
    {
      key: '泼尼松龙',
      scale: 5
    },
    {
      key: '甲泼尼龙',
      scale: 4
    },
    {
      key: '曲安西龙',
      scale: 4
    },
    {
      key: '倍他米松',
      scale: 0.75
    },
    {
      key: '地塞米松',
      scale: 0.75
    }
  ],
  // 脑灌注压
  'CPP.ICP': [
    {
      key: 'mmHg',
      zhName: '毫米汞柱',
      desc: '正常范围： 5~15mmHg <br>有效范围：0~22mmHg',
      scale: 1,
      min: 0,
      max: 22
    },
    {
      key: 'kPa',
      zhName: '千帕',
      desc: '正常范围： 0.7~2.0kPa <br>有效范围：0~3.0kPa',
      scale: 0.13328,
      min: 0,
      max: 3.0
    }
  ],
  'CPP.DBP': [
    {
      key: 'mmHg',
      zhName: '毫米汞柱',
      desc: '正常范围： 60~90mmHg <br>有效范围：0~150mmHg',
      scale: 1,
      min: 0,
      max: 150
    },
    {
      key: 'kPa',
      zhName: '千帕',
      desc: '正常范围： 8.0~12.0kPa <br>有效范围：0~20.0kPa',
      scale: 0.13328,
      min: 0,
      max: 20.0
    }
  ],
  'CPP.SBP': [
    {
      key: 'mmHg',
      zhName: '毫米汞柱',
      desc: '正常范围： 90~140mmHg <br>有效范围：0~300mmHg',
      scale: 1,
      min: 0,
      max: 300
    },
    {
      key: 'kPa',
      zhName: '千帕',
      desc: '正常范围： 12.0~18.7kPa <br>有效范围：0~40.0kPa',
      scale: 0.13328,
      min: 0,
      max: 40.0
    }
  ],
  score_zero_fortyTwo: [
    {
      key: '分',
      desc: '有效范围： 0 - 42 分',
      scale: 1,
      min: 0,
      max: 42
    }
  ],
  score_zero_ten: [
    {
      key: '分',
      scale: 1,
      min: 0,
      max: 10
    }
  ],
  wbc_count: [
    {
      key: 'cells/μL',
      scale: 1,
      min: 0
    }
  ],
  wbc_count_uni: [
    {
      key: 'x10⁹/L',
      scale: 1,
      min: 0
    }
  ],
  wbc_count_unique: [
    {
      key: 'x10¹²/L',
      scale: 1,
      min: 0
    }
  ],
  yellow_alcohol_concentration: [
    {
      key: 'mg/L',
      scale: 1,
      min: 0
    },
    {
      key: 'μg/L',
      scale: 1000,
      min: 0
    }
  ],
  'lungs.distance': [
    {
      key: 'cm',
      min: 0,
      scale: 1
    }
  ],
  'hem.per': [
    {
      key: '',
      desc: '有效范围： 0 - 100',
      scale: 1,
      min: 0,
      max: 100
    }
  ],
  'serum.bai': [
    {
      key: 'g/dL',
      desc: '有效范围： 0.5 - 10',
      scale: 1,
      min: 0,
      max: 10
    },
    {
      key: 'g/L',
      desc: '有效范围： 5 - 100',
      scale: 10,
      min: 5,
      max: 100
    }
  ],
  'bilirubin.hong': [
    {
      key: 'mg/dL',
      desc: '有效范围： 0.06 - 50',
      scale: 1,
      min: 0.06,
      max: 50
    },
    {
      key: 'mg/L',
      desc: '有效范围： 0.6 - 500',
      scale: 10,
      min: 0.6,
      max: 500
    }
  ],
  'International.tate': [
    {
      key: '',
      desc: '有效范围： 0.1 - 20',
      scale: 1,
      min: 0.1,
      max: 20
    }
  ],
  'GCS': [
    {
      key: '',
      desc: '有效范围： 3 - 15',
      scale: 1,
      min: 3,
      max: 15
    }
  ],
  'Urine.output': [
    {
      key: 'ml',
      desc: '',
      scale: 1,
      min: 0
    }
  ],
  'output.weight': [
    {
      key: 'kg',
      desc: '',
      scale: 1,
      min: 0
    }
  ],
  'output.hour': [
    {
      key: 'h',
      desc: '',
      scale: 1,
      min: 0
    }
  ],
  'differ.na.cl.hco': [
    {
      key: 'mmol/L',
      desc: '',
      scale: 1,
      min: 0
    }
  ],
  'differ.alb': [
    {
      key: 'g/L',
      desc: '',
      scale: 1,
      min: 0
    }
  ],
  'infiltration.gap.na': [
    {
      key: 'mmol/L',
      desc: '正常范围： 135 - 145',
      scale: 1
    }
  ],
  'infiltration.gap.k': [
    {
      key: 'mmol/L',
      desc: '正常范围： 3.5 - 5.0',
      scale: 1
    }
  ],
  'infiltration.gap.mo': [
    {
      key: 'mOsm/kg',
      desc: '正常范围： 275 - 295',
      scale: 1
    }
  ],
  'infiltration.gap.bun': [
    {
      key: 'mmol/L',
      desc: '正常范围： 3.2 - 7.1',
      scale: 1
    }
  ],
  'infiltration.gap.glu': [
    {
      key: 'mmol/L',
      desc: '正常范围： 3.9 - 6.1',
      scale: 1
    }
  ],
  // fascrcys
  'fas.scr': [

    {
      key: 'mg/dL',
      desc: '有效范围： 0.5-1.54mg/dL',
      scale: 1,
      min: 0.5,
      max: 1.54
    },
    {
      key: 'μmol/L',
      desc: '有效范围： 44-136mg/dL',
      scale: 88.4,
      min: 44,
      max: 136
    }
  ],
  'fas.cys': [

    {
      key: 'mg/dL',
      desc: '有效范围： 0.6-1.55mg/dL',
      scale: 1,
      min: 0.6,
      max: 1.55
    },
    {
      key: 'μmol/L',
      scale: 88.4
    }
  ],
  'gfr.blood': [
    {
      key: 'mg/dL',
      desc: '有效范围： 0.46-1.26mg/dL',
      scale: 1,
      min: 0.46,
      max: 1.26
    },

    {
      key: 'μmol/L',
      desc: '有效范围： 10-3000μmol/L',
      scale: 88.4,
      min: 10,
      max: 3000
    }
  ],
  'cao.PaO': [
    {
      key: 'mmHg',
      scale: 1
    }
  ],
  'cao.SaO': [
    {
      key: '%',
      scale: 1
    }
  ],
  'cao.Hb': [
    {
      key: 'g/L',
      scale: 1
    }
  ],
  'cr.any': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: '血清肌酐'
    }
  ],
  'aug.any': [
    {
      key: 'mg/mL/min',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: '血药浓度-时间曲线下面积'
    }
  ],
  'ca.seven.four': [
    {
      key: 'kU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'U/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }

  ],
  'homocysteine.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 82.5396,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    }
  ],
  'galactose.unit': [
    {
      key: 'mmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 180.16,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 18.016,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 18.016,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 180.16,
      min: 0,
      title: ''
    }
  ],
  'phenobarbital.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 4.306,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    }
  ],
  'Phenylalanine.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 60.5364,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    }
  ],
  'Pyrrolysine.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 39.1676,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    }
  ],
  'Alanine.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 112.246,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    },
    {
      key: 'μg/L',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    }
  ],
  'Alanine.Aminotransferase.unit': [
    {
      key: 'nkat/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μkat/L',
      desc: '有效范围： 任何数值',
      scale: 0.001,
      min: 0,
      title: ''
    },
    {
      key: 'U/L',
      desc: '有效范围： 任何数值',
      scale: 0.06,
      min: 0,
      title: ''
    },
    {
      key: 'IU/L',
      desc: '有效范围： 任何数值',
      scale: 0.06,
      min: 0,
      title: ''
    }

  ],
  'Acetone.unit': [
    {
      key: 'mmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 5.808,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 5.808,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 58.08,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 58.08,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 58.08,
      min: 0,
      title: ''
    }
  ],
  'Valproic.acid.unit': [
    {
      key: 'mmol/L',
      desc: '有效范围： 任何数值',
      scale: 6.9343,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Complement.Component.three.unit': [
    {
      key: 'g/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },

    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },

    {
      key: 'mg/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Complement.Component.four.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 5,
      min: 0,
      title: ''
    },

    {
      key: 'g/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },

    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'mg/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Unsaturated.Iron.Binding.Capacity.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },

    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 0.0558,
      min: 0,
      title: ''
    },
    {
      key: 'μg/dL',
      desc: '有效范围： 任何数值',
      scale: 5.5845,
      min: 0,
      title: ''
    },

    {
      key: 'μg%',
      desc: '有效范围： 任何数值',
      scale: 5.5845,
      min: 0,
      title: ''
    },
    {
      key: 'μg/L',
      desc: '有效范围： 任何数值',
      scale: 55.845,
      min: 0,
      title: ''
    }

  ],
  'Theophylline.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 5.5505,
      min: 0,
      title: ''
    },

    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    },

    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    },
    {
      key: 'ug/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }

  ],
  'Erythropoietin.unit': [
    {
      key: 'IU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mIU/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Activated.Partial.Thromboplastin.Time.unit': [
    {
      key: 's',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'sec',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Progesterone.unit': [
    {
      key: 'nmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'pmol/L',
      desc: '有效范围： 任何数值',
      scale: 1000,
      min: 0,
      title: ''
    },
    {
      key: 'ng/mL',
      desc: '有效范围： 任何数值',
      scale: 0.3145,
      min: 0,
      title: ''
    },
    {
      key: 'ng/dL',
      desc: '有效范围： 任何数值',
      scale: 31.446,
      min: 0,
      title: ''
    },
    {
      key: 'ng/100mL',
      desc: '有效范围： 任何数值',
      scale: 31.446,
      min: 0,
      title: ''
    },
    {
      key: 'ng%',
      desc: '有效范围： 任何数值',
      scale: 31.446,
      min: 0,
      title: ''
    },
    {
      key: 'ng/L',
      desc: '有效范围： 任何数值',
      scale: 314.46,
      min: 0,
      title: ''
    },
    {
      key: 'ug/L',
      desc: '有效范围： 任何数值',
      scale: 0.3145,
      min: 0,
      title: ''
    }
  ],
  'Cardiac.Troponin.I.unit': [
    {
      key: 'ng/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'pg/mL',
      desc: '有效范围： 任何数值',
      scale: 1000,
      min: 0,
      title: ''
    },
    {
      key: 'ng/dL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'ng/100mL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'ng%',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'ng/L',
      desc: '有效范围： 任何数值',
      scale: 1000,
      min: 0,
      title: ''
    },
    {
      key: 'ug/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Mean.Corpuscular.Volume.unit': [
    {
      key: 'fL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μm³',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'cu μm',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'cubic μm',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Mean.Corpuscular.Hemoglobin.unit': [
    {
      key: 'fmol',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'fmol/cell',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'pg',
      desc: '有效范围： 任何数值',
      scale: 16.114,
      min: 0,
      title: ''
    },
    {
      key: 'pg/cell',
      desc: '有效范围： 任何数值',
      scale: 16.114,
      min: 0,
      title: ''
    }
  ],
  'Mean.Corpuscular.Hemoglobin.Concentration.unit': [
    {
      key: 'mmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 1000,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 1.6114,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 1.6114,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 1.6114,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 16.114,
      min: 0,
      title: ''
    },
    {
      key: 'mg/mL',
      desc: '有效范围： 任何数值',
      scale: 16.114,
      min: 0,
      title: ''
    },
    {
      key: '%',
      desc: '有效范围： 任何数值',
      scale: 1.6114,
      min: 0,
      title: ''
    }
  ],
  'Mean.Platelet.Volume.unit': [
    {
      key: 'fL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μm³',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'cu μm',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'cubic μm',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Human.Epididymis.Protein.four.unit': [
    {
      key: 'nmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'pmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Human.Growth.Hormone.unit': [
    {
      key: 'mIU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'ng/mL',
      desc: '有效范围： 任何数值',
      scale: 0.333,
      min: 0,
      title: ''
    },
    {
      key: 'ng/dL',
      desc: '有效范围： 任何数值',
      scale: 33.3,
      min: 0,
      title: ''
    },
    {
      key: 'ng/100mL',
      desc: '有效范围： 任何数值',
      scale: 33.3,
      min: 0,
      title: ''
    },
    {
      key: 'ng%',
      desc: '有效范围： 任何数值',
      scale: 33.3,
      min: 0,
      title: ''
    },
    {
      key: 'μg/L',
      desc: '有效范围： 任何数值',
      scale: 0.333,
      min: 0,
      title: ''
    }
  ],
  'Elbow_HSS_score.unit': [
    {
      key: 'ᐤ',
      desc: '',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Human.Chorionic.Gonadotropin.unit': [
    {
      key: 'mlU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'IU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mlU/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Pregnancy.Associated.Plasma.Protein.A.unit': [
    {
      key: 'mIU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μIU/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'IU/L',
      desc: '有效范围： 任何数值',
      scale: 0.001,
      min: 0,
      title: ''
    },
    {
      key: 'mIU/mL',
      desc: '有效范围： 任何数值',
      scale: 0.001,
      min: 0,
      title: ''
    }
  ],
  'Lactic.Acid.unit': [
    {
      key: 'mmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 1000,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 9.008,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 9.008,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 9.008,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 90.08,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 90.08,
      min: 0,
      title: ''
    }
  ],
  'Lactate.Dehydrogenase.unit': [
    {
      key: 'nkat/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μkat/L',
      desc: '有效范围： 任何数值',
      scale: 0.001,
      min: 0,
      title: ''
    },
    {
      key: 'U/L',
      desc: '有效范围： 任何数值',
      scale: 0.06,
      min: 0,
      title: ''
    },
    {
      key: 'IU/L',
      desc: '有效范围： 任何数值',
      scale: 0.06,
      min: 0,
      title: ''
    },
    {
      key: 'μmol/(min*L)',
      desc: '有效范围： 任何数值',
      scale: 0.06,
      min: 0,
      title: ''
    },
    {
      key: 'μmol/(h*L)',
      desc: '有效范围： 任何数值',
      scale: 3.6,
      min: 0,
      title: ''
    },
    {
      key: 'μmol/(h*mL)',
      desc: '有效范围： 任何数值',
      scale: 0.0036,
      min: 0,
      title: ''
    }
  ],
  'Calcitonin.unit': [
    {
      key: 'pmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'pg/mL',
      desc: '有效范围： 任何数值',
      scale: 3.4176,
      min: 0,
      title: ''
    },
    {
      key: 'pg/dL',
      desc: '有效范围： 任何数值',
      scale: 341.76,
      min: 0,
      title: ''
    },
    {
      key: 'pg/100mL',
      desc: '有效范围： 任何数值',
      scale: 341.76,
      min: 0,
      title: ''
    },
    {
      key: 'pg%',
      desc: '有效范围： 任何数值',
      scale: 341.76,
      min: 0,
      title: ''
    },
    {
      key: 'pg/L',
      desc: '有效范围： 任何数值',
      scale: 3417.6,
      min: 0,
      title: ''
    },
    {
      key: 'ng/L',
      desc: '有效范围： 任何数值',
      scale: 3.4176,
      min: 0,
      title: ''
    }
  ],
  'Procalcitonin.unit': [
    {
      key: 'ng/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'ng/dL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'ng/100mL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'ng%',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'ng/L',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'μg/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Haptoglobin.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'g/L',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    },
    {
      key: 'mg/mL',
      desc: '有效范围： 任何数值',
      scale: 0.1,
      min: 0,
      title: ''
    }
  ],
  'Arginine.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 0.0174,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 0.0174,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 0.0174,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 0.1742,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 0.1742,
      min: 0,
      title: ''
    }
  ],
  'Macroprolactin.unit': [
    {
      key: 'Fraction',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: '%',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    }
  ],
  'Carbamazepine.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 0.0236,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 0.0236,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 0.0236,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 0.0236,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 0.0236,
      min: 0,
      title: ''
    }
  ],
  'Anti.Cyclic.Citrullinated.Peptide.Antibodies.unit': [
    {
      key: 'U/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'kU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Antidiuretic_Hormone.unit': [
    {
      key: 'pmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'pg/mL',
      desc: '有效范围： 任何数值',
      scale: 1.0842,
      min: 0,
      title: ''
    },
    {
      key: 'ng/L',
      desc: '有效范围： 任何数值',
      scale: 1.0842,
      min: 0,
      title: ''
    },
    {
      key: 'ng/dL',
      desc: '有效范围： 任何数值',
      scale: 0.1084,
      min: 0,
      title: ''
    },
    {
      key: 'ng/100mL',
      desc: '有效范围： 任何数值',
      scale: 0.1084,
      min: 0,
      title: ''
    },
    {
      key: 'ng%',
      desc: '有效范围： 任何数值',
      scale: 0.1084,
      min: 0,
      title: ''
    }
  ],
  'Anti_Streptolysin_O.unit': [
    {
      key: 'U/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'IU/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'kU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'kIU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Anti_Müllerian_Hormone.unit': [
    {
      key: 'pmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'ng/mL',
      desc: '有效范围： 任何数值',
      scale: 0.14,
      min: 0,
      title: ''
    },
    {
      key: 'ng/dL',
      desc: '有效范围： 任何数值',
      scale: 14,
      min: 0,
      title: ''
    },
    {
      key: 'ng/100mL',
      desc: '有效范围： 任何数值',
      scale: 14,
      min: 0,
      title: ''
    },
    {
      key: 'ng%',
      desc: '有效范围： 任何数值',
      scale: 14,
      min: 0,
      title: ''
    },
    {
      key: 'ng/L',
      desc: '有效范围： 任何数值',
      scale: 140,
      min: 0,
      title: ''
    },
    {
      key: 'pg/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Antithrombin_Ⅲ.unit': [
    {
      key: '%',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'U/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'kU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Soluble_Fms_like_Tyrosine_Kinase_1.unit': [
    {
      key: 'pg/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'pg/dL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'pg/100mL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'pg%',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'pg/L',
      desc: '有效范围： 任何数值',
      scale: 1000,
      min: 0,
      title: ''
    },
    {
      key: 'ng/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Soluble_Transferrin_Receptor.unit': [
    {
      key: 'nmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mg/dL',
      desc: '有效范围： 任何数值',
      scale: 0.0085,
      min: 0,
      title: ''
    },
    {
      key: 'mg/100mL',
      desc: '有效范围： 任何数值',
      scale: 0.0085,
      min: 0,
      title: ''
    },
    {
      key: 'mg%',
      desc: '有效范围： 任何数值',
      scale: 0.0085,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 0.085,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 0.085,
      min: 0,
      title: ''
    }
  ],
  'Lymphocyte.unit': [
    {
      key: 'Fraction',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: '%',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    }
  ],
  'Lymphocyte_Absolute_Count.unit': [
    {
      key: '10⁹/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'G/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'Gpt/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'cells/L',
      desc: '有效范围： 任何数值',
      scale: 1000000000,
      min: 0,
      title: ''
    },
    {
      key: 'K/μL',
      desc: '有效范围： 任何数值',
      scale: 10,
      min: 0,
      title: ''
    },
    {
      key: 'K/mm³',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'cells/μL',
      desc: '有效范围： 任何数值',
      scale: 1000,
      min: 0,
      title: ''
    },
    {
      key: 'cells/mm³',
      desc: '有效范围： 任何数值',
      scale: 1000,
      min: 0,
      title: ''
    },
    {
      key: '10³/μL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: '10³/mm³',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Squamous_Cell_Carcinoma.unit': [
    {
      key: 'ng/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'ng/dL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'ng/100mL',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'ng%',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'ng/L',
      desc: '有效范围： 任何数值',
      scale: 100,
      min: 0,
      title: ''
    },
    {
      key: 'μg/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Dehydroepiandrosterone_Sulfate.unit': [
    {
      key: 'μmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μg/dL',
      desc: '有效范围： 任何数值',
      scale: 36.846,
      min: 0,
      title: ''
    },
    {
      key: 'μg/100mL',
      desc: '有效范围： 任何数值',
      scale: 36.846,
      min: 0,
      title: ''
    },
    {
      key: 'μg%',
      desc: '有效范围： 任何数值',
      scale: 36.846,
      min: 0,
      title: ''
    },
    {
      key: 'mg/L',
      desc: '有效范围： 任何数值',
      scale: 0.3685,
      min: 0,
      title: ''
    },
    {
      key: 'μg/mL',
      desc: '有效范围： 任何数值',
      scale: 0.3685,
      min: 0,
      title: ''
    },
    {
      key: 'μg/L',
      desc: '有效范围： 任何数值',
      scale: 368.46,
      min: 0,
      title: ''
    },
    {
      key: 'ng/L',
      desc: '有效范围： 任何数值',
      scale: 0.3685,
      min: 0,
      title: ''
    }

  ],
  'Chloride.unit': [
    {
      key: 'mmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'mEq/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Follicle_Stimulating_Hormone.unit': [
    {
      key: 'mIU/mL',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'IU/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    }
  ],
  'Digitoxin.unit': [
    {
      key: 'nmol/L',
      desc: '有效范围： 任何数值',
      scale: 1,
      min: 0,
      title: ''
    },
    {
      key: 'μg/dL',
      desc: '有效范围： 任何数值',
      scale: 0.0765,
      min: 0,
      title: ''
    },
    {
      key: 'μg/100mL',
      desc: '有效范围： 任何数值',
      scale: 0.0765,
      min: 0,
      title: ''
    },
    {
      key: 'μg%',
      desc: '有效范围： 任何数值',
      scale: 0.0765,
      min: 0,
      title: ''
    },
    {
      key: 'μg/L',
      desc: '有效范围： 任何数值',
      scale: 0.07649,
      min: 0,
      title: ''
    },
    {
      key: 'ng/mL',
      desc: '有效范围： 任何数值',
      scale: 0.07649,
      min: 0,
      title: ''
    }
  ],
  // 组氨酸单位
  'histidine': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0155
    },
    {
      key: 'mg/100mL',
      scale: 0.0155
    },
    {
      key: 'mg%',
      scale: 0.0155
    },
    {
      key: 'mg/L',
      scale: 0.1552
    },
    {
      key: 'μg/mL',
      scale: 0.1552
    }
  ],
  // 总铁结合力
  'TIBC': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mmol/L',
      scale: 0.001
    },
    {
      key: 'μg/dL',
      scale: 5.5845
    },
    {
      key: 'μg/100mL',
      scale: 5.5845
    },
    {
      key: 'μg%',
      scale: 5.5845
    },
    {
      key: 'μg/L',
      scale: 55.845
    },
    {
      key: 'ng/mL',
      scale: 55.845
    },
    {
      key: 'mg/L',
      scale: 0.0558
    }
  ],
  // 总蛋白
  'TP': [
    {
      key: 'g/L',
      scale: 1
    },
    {
      key: 'g/dL',
      scale: 0.1
    },
    {
      key: 'g/100mL',
      scale: 0.1
    },
    {
      key: 'g%',
      scale: 0.1
    },
    {
      key: 'mg/mL',
      scale: 1
    }
  ],
  // 总胆红素
  'TBIL': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 58.467
    },
    {
      key: 'm/100mL',
      scale: 58.467
    },
    {
      key: 'mg%',
      scale: 58.467
    },
    {
      key: 'mg/L',
      scale: 584.67
    },
    {
      key: 'μg/mL',
      scale: 584.67
    }
  ],
  // 游离三碘甲状腺原氨酸
  'FT3': [
    {
      key: 'pmol/L',
      scale: 1
    },
    {
      key: 'pg/mL',
      scale: 0.651
    },
    {
      key: 'pg/100mL',
      scale: 65.1
    },
    {
      key: 'pg%',
      scale: 65.1
    },
    {
      key: 'ng/dL',
      scale: 0.0651
    },
    {
      key: 'ng/gL',
      scale: 0.651
    }
  ],
  // 载脂蛋白A-1
  'Apo_A_1': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'g/L',
      scale: 28
    },
    {
      key: 'mg/dL',
      scale: 2800
    },
    {
      key: 'mg/100mL',
      scale: 2800
    },
    {
      key: 'mg%',
      scale: 2800
    },
    {
      key: 'mg/mL',
      scale: 28
    }
  ],
  // 载脂蛋白B
  'ApoB': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'g/L',
      scale: 513
    },
    {
      key: 'mg/dL',
      scale: 51300
    },
    {
      key: 'mg/100mL',
      scale: 51300
    },
    {
      key: 'mg%',
      scale: 51300
    },
    {
      key: 'mg/mL',
      scale: 513
    }
  ],
  // 脂蛋白(a)
  'LP_a': [
    {
      key: 'g/L',
      scale: 1
    },
    {
      key: 'mg/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 100
    },
    {
      key: 'mg/100mL',
      scale: 100
    },
    {
      key: 'mg%',
      scale: 100
    },
    {
      key: 'mg/mL',
      scale: 1
    }
  ],
  // 脂多糖结合蛋白
  'LBP': [
    {
      key: 'μg/mL',
      scale: 1
    },
    {
      key: 'mg/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.1
    },
    {
      key: 'mg/100mL',
      scale: 0.1
    },
    {
      key: 'mg%',
      scale: 0.1
    }
  ],
  // 脂肪酶
  'LPS': [
    {
      key: 'U/L',
      scale: 1
    },
    {
      key: 'IU/L',
      scale: 1
    },
    {
      key: 'μmol/（min·L）',
      scale: 1
    },
    {
      key: 'μmol/（h·L）',
      scale: 60
    },
    {
      key: 'μmol/（h·mL）',
      scale: 0.6
    },
    {
      key: 'nkat/L',
      scale: 16.667
    },
    {
      key: 'μkat/L',
      scale: 0.0167
    },
    {
      key: 'nmol/（s·L）',
      scale: 16.667
    },
    {
      key: 'μmol/（s·L）',
      scale: 0.0167
    }
  ],
  // 直接胆红素
  'DBIL': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 58.467
    },
    {
      key: 'mg/100mL',
      scale: 58.467
    },
    {
      key: 'mg%',
      scale: 58.467
    },
    {
      key: 'mg/L',
      scale: 584.67
    },
    {
      key: 'μg/mL',
      scale: 584.67
    }
  ],
  // 中性粒细胞占比
  'NEUT': [
    {
      key: 'Proportion of 1.0',
      scale: 1
    },
    {
      key: 'Fraction',
      scale: 1
    },
    {
      key: '%',
      scale: 100
    }
  ],
  // 转铁蛋白
  'TRF': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'g/L',
      scale: 0.0796
    },
    {
      key: 'mg/dL',
      scale: 7.96
    },
    {
      key: 'mg/100mL',
      scale: 7.96
    },
    {
      key: 'mg%',
      scale: 7.96
    },
    {
      key: 'mg/mL',
      scale: 0.0796
    }
  ],
  // 中性粒细胞计数
  'ANC': [
    {
      key: '10^9/L',
      scale: 1
    },
    {
      key: 'G/L',
      scale: 1
    },
    {
      key: 'Gpt/L',
      scale: 1
    },
    {
      key: '10^9cells/L',
      scale: 1
    },
    {
      key: '10^3/μL',
      scale: 1
    },
    {
      key: '10^3/mm^3',
      scale: 1
    },
    {
      key: 'K/μL',
      scale: 1
    },
    {
      key: 'K/mm^3',
      scale: 1
    },
    {
      key: 'cells/μL',
      scale: 1000
    },
    {
      key: 'cells/mm^3',
      scale: 1000
    }
  ],
  // 总Ⅰ型前胶原氨基端延长肽
  'TP1NP': [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'μg/L',
      scale: 1
    }
  ],
  // 总胆固醇
  'TC': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 38.665
    },
    {
      key: 'mg/100mL',
      scale: 38.665
    },
    {
      key: 'mg%',
      scale: 38.665
    },
    {
      key: 'mg/L',
      scale: 38.665
    },
    {
      key: 'μg/mL',
      scale: 38.665
    }
  ],
  // 钠
  'Na': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'mEq/L',
      scale: 1
    }
  ],
  // 尿素氮
  'BUN': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/mL',
      scale: 2.8
    },
    {
      key: 'mg/100mL',
      scale: 2.8
    },
    {
      key: 'mg%',
      scale: 2.8
    },
    {
      key: 'mg/L',
      scale: 28
    },
    {
      key: 'μg/mL',
      scale: 28
    }
  ],
  // 尿酸
  'UA': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 16.811
    },
    {
      key: 'mg/100mL',
      scale: 16.811
    },
    {
      key: 'mg%',
      scale: 16.811
    },
    {
      key: 'mg/L',
      scale: 168.11
    },
    {
      key: 'μg/mL',
      scale: 168.11
    }
  ],
  // 血红蛋白
  'HBG': [
    {
      key: 'g/L',
      scale: 1
    },
    {
      key: 'g/dL',
      scale: 0.1
    },
    {
      key: 'g/100mL',
      scale: 0.1
    },
    {
      key: 'g%',
      scale: 0.1
    },
    {
      key: 'mg/mL',
      scale: 1
    }
  ],
  // 血红蛋白单体（亚基）
  'Hemoglobin_subunit': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'g/L',
      scale: 16.114
    },
    {
      key: 'g/dL',
      scale: 1.6114
    },
    {
      key: 'g/100mL',
      scale: 1.6114
    },
    {
      key: 'g%',
      scale: 1.6114
    },
    {
      key: 'mg/mL',
      scale: 16.114
    }
  ],
  // 血红蛋白四聚体
  'Hemoglobin_tetramer': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'g/L',
      scale: 64.458
    },
    {
      key: 'g/dL',
      scale: 6.4458
    },
    {
      key: 'g/100mL',
      scale: 6.4458
    },
    {
      key: 'g%',
      scale: 6.4458
    },
    {
      key: 'mg/mL',
      scale: 64.458
    }
  ],
  // 血细胞比容
  'HCT': [
    {
      key: 'L/L',
      scale: 1
    },
    {
      key: '%',
      scale: 100
    }
  ],
  // 血小板
  'Blood_Platelet': [
    {
      key: '10^9/L',
      scale: 1
    },
    {
      key: 'G/L',
      scale: 1
    },
    {
      key: 'Gpt/L',
      scale: 1
    },
    {
      key: '10^9cells/L',
      scale: 1
    },
    {
      key: '10^3/μL',
      scale: 1
    },
    {
      key: '10^3/mm^3',
      scale: 1
    },
    {
      key: 'K/μL',
      scale: 1
    },
    {
      key: 'K/mm^3',
      scale: 1
    },
    {
      key: 'cells/μL',
      scale: 1000
    },
    {
      key: 'cells/mm^3',
      scale: 1000
    }
  ],
  // 叶酸
  'Folic_Acid': [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'μg/L',
      scale: 1
    },
    {
      key: 'nmol/L',
      scale: 2.2665
    },
    {
      key: 'pmol/L',
      scale: 2265.5188
    }
  ],
  // 叶酸盐
  'Folate': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'pmol/L',
      scale: 1000
    },
    {
      key: 'ng/mL',
      scale: 0.44
    },
    {
      key: 'ng/dL',
      scale: 44
    },
    {
      key: 'ng/100ml',
      scale: 44
    },
    {
      key: 'ng%',
      scale: 44
    },
    {
      key: 'μg/L',
      scale: 440
    }
  ],
  // 缬氨酸
  'Val': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0117
    },
    {
      key: 'mg/100mL',
      scale: 0.0117
    },
    {
      key: 'mg%',
      scale: 0.0117
    },
    {
      key: 'mg/L',
      scale: 0.117
    },
    {
      key: 'μg/mL',
      scale: 0.1172
    }
  ],
  // 性激素结合球蛋白
  'SHBG': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'μg/mL',
      scale: 0.095
    },
    {
      key: 'μg/dL',
      scale: 9.5
    },
    {
      key: 'μg/100mL',
      scale: 9.5
    },
    {
      key: 'μ%',
      scale: 9.5
    },
    {
      key: 'μg/L',
      scale: 95
    },
    {
      key: 'mg/L',
      scale: 0.095
    }
  ],
  // 促肾上腺皮质激素（ACTH）
  'acth': [
    {
      key: 'pmol/L',
      scale: 1
    },
    {
      key: 'pg/mL',
      scale: 4.541
    },
    {
      key: 'pg/dL',
      scale: 454.1
    },
    {
      key: 'pg/100mL',
      scale: 454.1
    },
    {
      key: 'pg%',
      scale: 454.1
    },
    {
      key: 'pg/L',
      scale: 4541
    },
    {
      key: 'ng/L',
      scale: 4.541
    }
  ],
  // 催乳素（PRL）
  'Prolactin': [
    {
      key: 'μg/L',
      scale: 1
    },
    {
      key: 'μIUmL',
      scale: 21.2766
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'mIU/L',
      scale: 21.2766
    }
  ],
  // 单核细胞
  'Monocytes': [
    {
      key: 'Proportion of 1.0',
      scale: 1
    },
    {
      key: 'Fraction',
      scale: 1
    },
    {
      key: '%',
      scale: 100
    }
  ],
  // 绝对单核细胞计数
  'Absolute_Monocyte_Count': [
    {
      key: '10^9/L',
      scale: 1
    },
    {
      key: 'G/L',
      scale: 1
    },
    {
      key: 'Gpt/L',
      scale: 1
    },
    {
      key: '10^3/μL',
      scale: 1
    },
    {
      key: 'K/μL',
      scale: 1
    },
    {
      key: 'K/mm^3',
      scale: 1
    },
    {
      key: 'cells/L',
      scale: 1000
    },
    {
      key: 'cells/mm^3',
      scale: 1000
    }
  ],
  // 胆碱酯酶
  'Cholinesterase': [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min·L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h·L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h·mL)',
      scale: 0.0036
    }
  ],
  // 蛋氨酸（Met）
  'Methionine': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0149
    },
    {
      key: 'mg/100mL',
      scale: 0.0149
    },
    {
      key: 'mg%',
      scale: 0.0149
    },
    {
      key: 'mg/L',
      scale: 0.1492
    },
    {
      key: 'μg/mL',
      scale: 0.1492
    }
  ],
  // 低密度脂蛋白胆固醇（LDL-C）
  'LDL-C': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 38.665
    },
    {
      key: 'mg/100mL',
      scale: 38.665
    },
    {
      key: 'mg%',
      scale: 38.665
    },
    {
      key: 'mg/L',
      scale: 386.65
    },
    {
      key: 'μg/mL',
      scale: 386.65
    }
  ],
  // 地高辛
  'Digoxin': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'μg/L',
      scale: 0.7809
    },
    {
      key: 'μg/dL',
      scale: 0.0781
    },
    {
      key: 'μg/100mL',
      scale: 0.0781
    },
    {
      key: 'μg%',
      scale: 0.0781
    },
    {
      key: 'ng/mL',
      scale: 0.7809
    }
  ],
  // 淀粉酶
  'Amylase': [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min·L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h·L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h·mL)',
      scale: 0.0036
    }
  ],
  // 对乙酰氨基酚
  'Acetaminophen': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/L',
      scale: 0.1512
    },
    {
      key: 'mg/dL',
      scale: 0.0151
    },
    {
      key: 'mg/100mL',
      scale: 0.0151
    },
    {
      key: 'μg/mL',
      scale: 0.1512
    }
  ],
  // 泛酸（维生素B5）
  'Pantothenic_Acid': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/L',
      scale: 0.2192
    },
    {
      key: 'mg/dL',
      scale: 0.0219
    },
    {
      key: 'mg/100mL',
      scale: 0.0219
    },
    {
      key: 'μg/mL',
      scale: 0.2192
    },
    {
      key: 'mg%',
      scale: 0.0219
    }
  ],
  // 脯氨酸
  'Proline': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/L',
      scale: 0.1151
    },
    {
      key: 'mg/dL',
      scale: 0.0115
    },
    {
      key: 'mg/100mL',
      scale: 0.0115
    },
    {
      key: 'μg/mL',
      scale: 0.1151
    }
  ],
  // 钙
  'Calcium': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 4.0078
    },
    {
      key: 'mg/100mL',
      scale: 4.0078
    },
    {
      key: 'mg%',
      scale: 4.0078
    },
    {
      key: 'mg/L',
      scale: 40.078
    },
    {
      key: 'μg/mL',
      scale: 40.078
    }
  ],
  // 甘氨酸（Gly）
  'Glycine': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'mg/L',
      scale: 0.0751
    },
    {
      key: 'mg/dL',
      scale: 0.0075
    },
    {
      key: 'mg/100mL',
      scale: 0.0075
    },
    {
      key: 'μg/mL',
      scale: 0.0751
    },
    {
      key: 'mg%',
      scale: 0.0075
    }
  ],
  // 甘油三酯（TG）
  'Triglycerides': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/L',
      scale: 885.7
    },
    {
      key: 'mg/dL',
      scale: 88.57
    },
    {
      key: 'mg/100mL',
      scale: 88.57
    },
    {
      key: 'μg/mL',
      scale: 885.7
    }
  ],
  // 高密度脂蛋白胆固醇（HDL-C）
  'HDL-C': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 38.665
    },
    {
      key: 'mg/100mL',
      scale: 38.665
    },
    {
      key: 'mg%',
      scale: 38.665
    },
    {
      key: 'mg/L',
      scale: 386.65
    },
    {
      key: 'μg/mL',
      scale: 386.65
    }
  ],
  // 睾酮
  'Testosterone': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 0.2884
    },
    {
      key: 'ng/dL',
      scale: 28.842
    },
    {
      key: 'ng/100mL',
      scale: 28.842
    },
    {
      key: 'ng%',
      scale: 28.842
    },
    {
      key: 'ng/L',
      scale: 288.42
    },
    {
      key: 'μg/L',
      scale: 0.2884
    }
  ],
  // 谷氨酸
  'Glutamic_Acid': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0147
    },
    {
      key: 'mg/100mL',
      scale: 0.0147
    },
    {
      key: 'mg%',
      scale: 0.0147
    },
    {
      key: 'mg/L',
      scale: 0.1471
    },
    {
      key: 'μg/mL',
      scale: 0.1471
    }
  ],
  // 谷氨酸脱氢酶（GLDH）
  'GLDH': [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'nmol/(S·L)',
      scale: 1
    },
    {
      key: 'umol/(S·L)',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min·L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h·L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h·mL)',
      scale: 0.0036
    }
  ],
  // 谷氨酰胺（Gln）
  'Glutamine': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0146
    },
    {
      key: 'mg/100mL',
      scale: 0.0146
    },
    {
      key: 'mg%',
      scale: 0.0146
    },
    {
      key: 'mg/L',
      scale: 0.1461
    },
    {
      key: 'μg/mL',
      scale: 0.1461
    }
  ],
  // 骨钙素（OCN）
  'Osteocalcin': [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'μg/L',
      scale: 1
    }
  ],
  // 同型半胱氨酸（Hcy）
  'Homocysteine': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0135
    },
    {
      key: 'mg/100mL',
      scale: 0.0135
    },
    {
      key: 'mg%',
      scale: 0.0135
    },
    {
      key: 'mg/L',
      scale: 0.1352
    },
    {
      key: 'μg/mL',
      scale: 0.1352
    }
  ],
  // 胱氨酸（Cys）
  'Cysteine': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.024
    },
    {
      key: 'mg/100mL',
      scale: 0.024
    },
    {
      key: 'mg%',
      scale: 0.024
    },
    {
      key: 'mg/L',
      scale: 0.2403
    },
    {
      key: 'μg/mL',
      scale: 0.2403
    }
  ],
  // 亮氨酸（Leu）
  'Leucine': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0131
    },
    {
      key: 'mg/100mL',
      scale: 0.0131
    },
    {
      key: 'mg%',
      scale: 0.0131
    },
    {
      key: 'mg/L',
      scale: 0.1312
    },
    {
      key: 'μg/mL',
      scale: 0.1312
    }
  ],
  // 酪氨酸（Tyr）
  'Tyrosine': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0181
    },
    {
      key: 'mg/100mL',
      scale: 0.0181
    },
    {
      key: 'mg%',
      scale: 0.0181
    },
    {
      key: 'mg/L',
      scale: 0.1812
    },
    {
      key: 'μg/mL',
      scale: 0.1812
    }
  ],
  // 赖氨酸
  'Lysine': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0146
    },
    {
      key: 'mg/100mL',
      scale: 0.0146
    },
    {
      key: 'mg%',
      scale: 0.0146
    },
    {
      key: 'mg/L',
      scale: 0.1462
    },
    {
      key: 'μg/mL',
      scale: 0.1462
    }
  ],
  // 果糖
  'Fructose': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 18.016
    },
    {
      key: 'mg/100mL',
      scale: 18.016
    },
    {
      key: 'mg%',
      scale: 18.016
    },
    {
      key: 'mg/L',
      scale: 180.16
    },
    {
      key: 'μg/mL',
      scale: 180.16
    }
  ],
  // 纤维蛋白原
  'Fibrinogen': [
    {
      key: 'g/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 100
    },
    {
      key: 'mg/100mL',
      scale: 100
    },
    {
      key: 'mg%',
      scale: 100
    },
    {
      key: 'mg/L',
      scale: 1000
    },
    {
      key: 'μg/mL',
      scale: 1000
    }
  ],
  // 凝血酶时间（TT）
  'Thrombin_Time': [
    {
      key: 's',
      scale: 1
    },
    {
      key: 'sec',
      scale: 1
    }
  ],
  // 凝血酶原时间（PT）
  'Prothrombin_Time': [
    {
      key: 's',
      scale: 1
    },
    {
      key: 'sec',
      scale: 1
    }
  ],
  // 嗜酸性粒细胞
  'Eosinophil': [
    {
      key: 'Fraction',
      scale: 1
    },
    {
      key: '%',
      scale: 100
    }
  ],
  // 嗜酸性粒细胞绝对计数
  'Absolute_Eosinophil_Count': [
    {
      key: '10^9L',
      scale: 1
    },
    {
      key: 'G/L',
      scale: 1
    },
    {
      key: 'Gpt/L',
      scale: 1
    },
    {
      key: 'cells/L',
      scale: 1000000000
    },
    {
      key: 'K/μL',
      scale: 1
    },
    {
      key: 'K/mm^3',
      scale: 1
    },
    {
      key: 'cells/L',
      scale: 1000
    },
    {
      key: 'cells/mm^3',
      scale: 1000
    }
  ],
  // 嗜酸性粒细胞阳离子蛋白（ECP）
  'Eosinophil_Cationic_Protein': [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'μg/L',
      scale: 1
    }
  ],
  // 嗜碱性粒细胞（嗜碱性粒细胞绝对计数）
  'Basophil_Absolute_Count': [
    {
      key: '10^9L',
      scale: 1
    },
    {
      key: 'G/L',
      scale: 1
    },
    {
      key: 'Gpt/L',
      scale: 1
    },
    {
      key: 'cells/L',
      scale: 1000000000
    },
    {
      key: 'K/μL',
      scale: 1
    },
    {
      key: 'K/mm^3',
      scale: 1
    },
    {
      key: 'cells/L',
      scale: 1000
    },
    {
      key: 'cells/mm^3',
      scale: 1000
    }
  ],
  // 嗜碱性粒细胞
  'Basophils': [
    {
      key: 'Fraction',
      scale: 1
    },
    {
      key: '%',
      scale: 100
    }
  ],
  // 免疫球蛋白G（IgG）
  'Immunoglobulin_G': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 97.1
    },
    {
      key: 'mg/100mL',
      scale: 97.1
    },
    {
      key: 'mg%',
      scale: 97.1
    },
    {
      key: 'g/L',
      scale: 0.971
    },
    {
      key: 'mg/mL',
      scale: 0.971
    }
  ],
  // 葡萄糖
  'Glucose': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/L',
      scale: 180.16
    },
    {
      key: 'mg/dL',
      scale: 18.016
    },
    {
      key: 'mg/100mL',
      scale: 18.016
    },
    {
      key: 'μg/mL',
      scale: 180.16
    }
  ],
  // 前白蛋白（PA）
  'Prealbumin': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'g/dL',
      scale: 5.5
    },
    {
      key: 'g/100mL',
      scale: 5.5
    },
    {
      key: 'g%',
      scale: 5.5
    },
    {
      key: 'mg/mL',
      scale: 0.055
    },
    {
      key: 'g/L',
      scale: 0.055
    }
  ],
  // 前列腺特异性抗原（PSA）
  'Prostate_Specific_Antigen': [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'μg/L',
      scale: 1
    }
  ],
  // 庆大霉素
  'Gentamicin': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0478
    },
    {
      key: 'mg/100mL',
      scale: 0.0478
    },
    {
      key: 'mg%',
      scale: 0.0478
    },
    {
      key: 'mg/L',
      scale: 0.478
    },
    {
      key: 'μg/mL',
      scale: 0.4776
    }
  ],
  // 利多卡因
  'Lidocaine': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0234
    },
    {
      key: 'mg/100mL',
      scale: 0.0234
    },
    {
      key: 'mg%',
      scale: 0.0234
    },
    {
      key: 'mg/L',
      scale: 0.2343
    },
    {
      key: 'μg/mL',
      scale: 0.2343
    },
    {
      key: '%溶液',
      scale: 0.234
    }
  ],
  // 胱抑素C（Cys C）
  'Cystatin_C': [
    {
      key: 'mg/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.1
    },
    {
      key: 'mg/100mL',
      scale: 0.1
    },
    {
      key: 'mg%',
      scale: 0.1
    },
    {
      key: 'μg/mL',
      scale: 1
    }
  ],
  // 肌红蛋白（Mb）
  'Myoglobin': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 17.5
    },
    {
      key: 'ng/dL',
      scale: 1750
    },
    {
      key: 'ng/100mL',
      scale: 1750
    },
    {
      key: 'ng%',
      scale: 1750
    },
    {
      key: 'ng/L',
      scale: 17500
    },
    {
      key: 'μg/L',
      scale: 17.5
    }
  ],
  // 肌酸激酶（CK）
  'Creatine_Kinase': [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'nmol/(s·L)',
      scale: 1
    },
    {
      key: 'umol/(s·L)',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min·L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h·L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h·mL)',
      scale: 0.0036
    }
  ],
  // 甲状旁腺激素（PTH）
  'parathyroid_hormone': [
    {
      key: 'pmol/L',
      scale: 1
    },
    {
      key: 'pg/mL',
      scale: 9.43
    },
    {
      key: 'pg/dL',
      scale: 943
    },
    {
      key: 'pg/100mL',
      scale: 943
    },
    {
      key: 'pg%',
      scale: 943
    },
    {
      key: 'pg/L',
      scale: 9430
    },
    {
      key: 'ng/L',
      scale: 9.43
    }
  ],
  // 甲状腺过氧化物酶抗体（Anti-TPO）
  'Antithyroid_peroxidase_antibody': [
    {
      key: 'IU/mL',
      scale: 1
    },
    {
      key: 'kIU/L',
      scale: 1
    }
  ],
  // 甲状腺球蛋白（Tg）
  'Thyroglobulin': [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'μg/L',
      scale: 1
    }
  ],
  // 甲状腺球蛋白抗体（Anti-Tg）
  'Anti_Thyroglobulin_Antibodies': [
    {
      key: 'kIU/L',
      scale: 1
    },
    {
      key: 'IU/mL',
      scale: 1
    }
  ],
  // 甲状腺摄取
  'Thyroid_Uptake': [
    {
      key: 'Proportion of 1.0',
      scale: 1
    },
    {
      key: '%',
      scale: 1
    }
  ],
  // 甲状腺素（TT4）
  'Total_Thyroxine': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 0.0777
    },
    {
      key: 'μg/100mL',
      scale: 0.0777
    },
    {
      key: 'μg%',
      scale: 0.0777
    },
    {
      key: 'μg/L',
      scale: 0.7769
    },
    {
      key: 'ng/mL',
      scale: 0.7769
    }
  ],
  // 醛固酮
  'Aldosterone': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 0.3605
    },
    {
      key: 'ng/dL',
      scale: 36.045
    },
    {
      key: 'ng/100mL',
      scale: 36.045
    },
    {
      key: 'ng%',
      scale: 36.045
    },
    {
      key: 'ng/L',
      scale: 360.45
    },
    {
      key: 'pg/mL',
      scale: 360.45
    }
  ],
  // 醛缩酶（ALD）
  'Aldolase': [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min·L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h·L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h·mL)',
      scale: 0.0036
    },
    {
      key: 'nmol/(s·L)',
      scale: 1
    },
    {
      key: 'μmol/(s·L)',
      scale: 0.001
    }
  ],
  // 果糖胺
  'Fructosamine': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    }
  ],
  // 核黄素（维生素B2）
  'Riboflavin': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 0.0376
    },
    {
      key: 'μg/100mL',
      scale: 0.0376
    },
    {
      key: 'μg%',
      scale: 0.0376
    },
    {
      key: 'μg/L',
      scale: 0.3764
    },
    {
      key: 'ng/mL',
      scale: 0.3764
    }
  ],
  // 红细胞分布宽度标准差（RDW-SD）
  'Red_Cell_Distribution_Width_Standard_Deviation': [
    {
      key: 'fL',
      scale: 1
    },
    {
      key: 'μm^3',
      scale: 1
    }
  ],
  // 红细胞分布宽度变异系数（RDW-CV）
  'Red_Cell_Distribution_Width': [
    {
      key: 'Proportion of 1.0',
      scale: 1
    },
    {
      key: '%',
      scale: 100
    }
  ],
  // 甲状腺素结合球蛋白（TBG）
  'Thyroxine_binding_Globulin': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'μg/mL',
      scale: 0.054
    },
    {
      key: 'μg/L',
      scale: 54
    },
    {
      key: 'mg/L',
      scale: 0.054
    },
    {
      key: 'mg/dL',
      scale: 0.0054
    },
    {
      key: 'mg/100mL',
      scale: 0.0054
    },
    {
      key: 'mg%',
      scale: 0.0054
    }
  ],
  // 钾（K）
  'Potassium': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'mEq/L',
      scale: 1
    }
  ],
  // 碱性磷酸酶（ALP）
  'Alkaline_Phosphatase': [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'nmol/(s·L)',
      scale: 1
    },
    {
      key: 'umol/(s·L)',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min·L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h·L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h·mL)',
      scale: 0.0036
    }
  ],
  // 免疫球蛋白M（IgM）
  'Immunoglobulin_M': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 97.1
    },
    {
      key: 'mg/100mL',
      scale: 97.1
    },
    {
      key: 'mg%',
      scale: 97.1
    },
    {
      key: 'g/L',
      scale: 0.971
    },
    {
      key: 'mg/mL',
      scale: 0.971
    }
  ],
  // 癌抗原125（CA125）
  'Cancer_Antigen': [
    {
      key: 'U/mL',
      scale: 1
    },
    {
      key: 'kU/L',
      scale: 1
    }
  ],
  // α1-微球蛋白
  'a1_Microglobulin': [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'nmol/L',
      scale: 1000
    },
    {
      key: 'mg/L',
      scale: 30
    },
    {
      key: 'mg/100mL',
      scale: 3
    },
    {
      key: 'μg/mL',
      scale: 30
    }
  ],
  // α1-酸性糖蛋白
  'a1_acid_glycoprotein': [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'g/L',
      scale: 40
    },
    {
      key: 'g/dL',
      scale: 4000
    },
    {
      key: 'g/100mL',
      scale: 4000
    },
    {
      key: 'mg/mL',
      scale: 40
    },
    {
      key: 'mg/L',
      scale: 40000
    }
  ],
  // γ轻链
  'Gamma_Light_Chain': [
    {
      key: 'g/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 100
    },
    {
      key: 'mg/100mL',
      scale: 100
    },
    {
      key: 'mg%',
      scale: 100
    },
    {
      key: 'mg/mL',
      scale: 1
    },
    {
      key: 'mg/L',
      scale: 1000
    }
  ],
  // k轻链
  'Kappa_Light_Chain': [
    {
      key: 'g/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 100
    },
    {
      key: 'mg/100mL',
      scale: 100
    },
    {
      key: 'mg/mL',
      scale: 1
    },
    {
      key: 'mg/L',
      scale: 1000
    }
  ],
  // γ-谷氨酰转肽酶（GGT）
  'Gamma_Glutamyl_Transferase': [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'U/L',
      scale: 0.06
    }
  ],
  // β2-微球蛋白(β2-M)
  'Beta_2_Microglobulin': [
    {
      key: 'nmol/L',
      scale: 84.8176
    },
    {
      key: 'mg/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.1
    },
    {
      key: 'mg/100mL',
      scale: 0.1
    },
    {
      key: 'μg/mL',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 1000
    }
  ],
  // β-羟丁酸
  p_Hydroxybutyrate: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 10.411
    },
    {
      key: 'mg/100mL',
      scale: 10.411
    },
    {
      key: 'mg/L',
      scale: 104.11
    },
    {
      key: 'μg/mL',
      scale: 104.11
    }
  ],
  // β-胶原降解产物（Ⅰ型胶原降解产物）
  p_C_telopeptides_of_type_I_collagen: [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'pg/mL',
      scale: 1000
    }
  ],
  // α1-抗胰蛋白酶（α1-AT）
  a1_antitrypsin: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 100
    },
    {
      key: 'g/L',
      scale: 54.35
    },
    {
      key: 'g/dL',
      scale: 5435
    },
    {
      key: 'g/100mL',
      scale: 5435
    },
    {
      key: 'mg/mL',
      scale: 54.35
    }
  ],
  // TSH受体抗体（Anti-TSHR）
  TSHR_antibodies: [
    {
      key: 'IU/L',
      scale: 1
    },
    {
      key: 'KIU/L',
      scale: 1
    }
  ],
  // 促甲状腺激素（TSH）
  Thyroid_Stimulating_Hormone: [
    {
      key: 'μU/mL',
      scale: 1
    },
    {
      key: 'mIU/L',
      scale: 1
    }
  ],
  // S100蛋白
  S100_protein: [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'μg/L',
      scale: 1
    }
  ],
  // N末端B型利钠肽原（NT-proBNP）
  N_terminal_pro_B_type_natriuretic_peptide: [
    {
      key: 'pmol/L',
      scale: 1
    },
    {
      key: 'pg/mL',
      scale: 8.457
    },
    {
      key: 'pg/dL',
      scale: 845.7
    },
    {
      key: 'pg/100mL',
      scale: 845.7
    },
    {
      key: 'pg%',
      scale: 845.7
    },
    {
      key: 'pg/L',
      scale: 8457
    },
    {
      key: 'ng/L',
      scale: 8.457
    }
  ],
  // C肽
  C_Peptide: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'pmol/L',
      scale: 1000
    },
    {
      key: 'ng/mL',
      scale: 3.0203
    },
    {
      key: 'ng/dL',
      scale: 302.029
    },
    {
      key: 'ng/100mL',
      scale: 302.029
    },
    {
      key: 'ng%',
      scale: 302.029
    },
    {
      key: 'ng/L',
      scale: 3020.29
    },
    {
      key: 'μg/L',
      scale: 3.0203
    }
  ],
  // N1-甲基烟酰胺（烟酸代谢物）
  N1_methylnicotinamide: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 0.1372
    },
    {
      key: 'μg/L',
      scale: 0.1372
    },
    {
      key: 'μg/dL',
      scale: 0.0137
    },
    {
      key: 'μg/100mL',
      scale: 0.0137
    },
    {
      key: 'μg%',
      scale: 0.0137
    }
  ],
  // N-乙酰普鲁卡因酰胺（NAPA）
  N_Acetylprocainamide: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'μg/mL',
      scale: 0.2774
    },
    {
      key: 'mg/L',
      scale: 0.2774
    },
    {
      key: 'mg/dL',
      scale: 0.0277
    },
    {
      key: 'mg/100mL',
      scale: 0.0277
    },
    {
      key: 'mg%',
      scale: 0.0277
    }
  ],
  // CK-MB质量（定量检测）
  CK_MB_Mass: [
    {
      key: 'μg/L',
      scale: 1
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    }
  ],
  // CK-MB（活性）
  CK_MB_Activity: [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(s*L)',
      scale: 0.001
    },
    {
      key: 'μmol/(min*L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h*L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h*mL)',
      scale: 0.0036
    }
  ],
  // C-反应蛋白
  C_reactive_protein: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'mg/L',
      scale: 0.105
    },
    {
      key: 'mg/dL',
      scale: 0.105
    },
    {
      key: 'mg/100mL',
      scale: 0.0105
    },
    {
      key: 'mg%',
      scale: 0.0105
    },
    {
      key: 'μg/mL',
      scale: 0.0105
    },
    {
      key: 'g/L',
      scale: 0.0001
    }
  ],
  // 17-羟孕酮
  '17_α_hydroxy_progesterone': [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 0.3305
    },
    {
      key: 'ng/dL',
      scale: 33.046
    },
    {
      key: 'ng/100mL',
      scale: 33.046
    },
    {
      key: 'ng%',
      scale: 33.046
    },
    {
      key: 'ng/L',
      scale: 330.46
    },
    {
      key: 'μg/L',
      scale: 0.3305
    }
  ],
  // 游离人绒毛膜促性腺激素β亚基（游离βhCG）
  βHCG: [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'mIU/mL',
      scale: 1
    },
    {
      key: 'IU/L',
      scale: 1
    }
  ],
  // 游离前列腺特异性抗原
  Free_PSA: [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'n/L',
      scale: 1000
    },
    {
      key: 'μg/L',
      scale: 1
    }
  ],
  // 游离甲状腺素
  FT4: [
    {
      key: 'ng/dL',
      scale: 1
    },
    {
      key: 'ng/100mL',
      scale: 1
    },
    {
      key: 'ng%',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 0.01
    },
    {
      key: 'ng/L',
      scale: 10
    },
    {
      key: 'pg/mL',
      scale: 10
    },
    {
      key: 'pmol/L',
      scale: 12.872
    }
  ],
  // 游离雌三醇  1=100=100=100=1000=1
  E3: [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'μg/L',
      scale: 1
    }
  ],
  // 异亮氨酸
  lle: [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'μg/L',
      scale: 1
    }
  ],
  // 胰岛素样生长因子1
  IGF_1: [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'μg/L',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 0.1
    },
    {
      key: 'μg/100mL',
      scale: 0.1
    },
    {
      key: 'μg%',
      scale: 0.1
    },
    {
      key: 'nmol/L',
      scale: 0.1307
    }
  ],
  // 雄烯二酮
  Androstenedione: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 0.2864
    },
    {
      key: 'ng/dL',
      scale: 28.64
    },
    {
      key: 'ng/100mL',
      scale: 28.64
    },
    {
      key: 'μg%',
      scale: 28.64
    },
    {
      key: 'ng/L',
      scale: 286.4
    },
    {
      key: 'μg/L',
      scale: 0.2864
    }
  ],
  // 胰岛素样生长因子结合蛋白3
  IGFBP_3: [
    {
      key: 'μg/mL',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 100
    },
    {
      key: 'μg/100mL',
      scale: 100
    },
    {
      key: 'μg%',
      scale: 100
    },
    {
      key: 'μg/L',
      scale: 1000
    },
    {
      key: 'mg/L',
      scale: 1
    }
  ],
  // 胰淀粉酶
  p_AMY: [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'nmol/(s·L)',
      scale: 1
    },
    {
      key: 'μmol/(s·L)',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min·L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h·L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h·mL)',
      scale: 0.0036
    }
  ],
  // 乙醇脱氢酶
  ADH: [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'nmol/(s·L)',
      scale: 1
    },
    {
      key: 'μmol/(s·L)',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min·L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h·L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h·mL)',
      scale: 0.0036
    }
  ],
  // 乙酰乙酸（乙酰乙酸盐）
  ACAC: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 10.2088
    },
    {
      key: 'mg/100mL',
      scale: 10.2088
    },
    {
      key: 'mg%',
      scale: 10.2088
    },
    {
      key: 'mg/L',
      scale: 102.088
    },
    {
      key: 'μg/mL',
      scale: 102.088
    }
  ],
  // 异丙醇
  Isopropanol: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 6.0096
    },
    {
      key: 'mg/100mL',
      scale: 6.0096
    },
    {
      key: 'mg%',
      scale: 6.0096
    },
    {
      key: 'mg/L',
      scale: 60.096
    },
    {
      key: 'μg/mL',
      scale: 60.096
    }
  ],
  // 癌胚抗原
  Carcinoembryonic_Antigen: [
    {
      key: 'μg/L',
      scale: 1
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'ng/mL',
      scale: 1
    }
  ],
  // 胰岛素
  Insulin_Unit_Conversion: [
    {
      key: 'μIU/mL',
      scale: 1
    },
    {
      key: 'mlIU/L',
      scale: 1
    },
    {
      key: 'pmol/L',
      scale: 6
    }
  ],
  // 尿素
  Urea_unit_conversion: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 6.006
    },
    {
      key: 'mg/L',
      scale: 60.06
    },
    {
      key: 'μg/mL',
      scale: 60.06
    },
    {
      key: 'mg/100ml',
      scale: 6.006
    }
  ],
  // 肌酐
  Unit_conversionOfCreatinine: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/dL',
      scale: 11.3126
    },
    {
      key: 'mg/L',
      scale: 113.126
    },
    {
      key: 'μg/mL',
      scale: 113.126
    },
    {
      key: 'mg/100ml',
      scale: 11.3126
    }
  ],
  // 红细胞
  RBC_UnitConversion: [
    {
      key: '10^9/L',
      scale: 1
    },
    {
      key: 'T/L',
      scale: 1
    },
    {
      key: 'Tpt/L',
      scale: 1
    },
    {
      key: '10^12 cells/L',
      scale: 1
    },
    {
      key: '10^6/μL',
      scale: 1
    },
    {
      key: '10^6/mm^3',
      scale: 1
    },
    {
      key: '10^6 cells/μL',
      scale: 1
    },
    {
      key: '10^6 cells/mm^3',
      scale: 1
    },
    {
      key: 'M/mm^3',
      scale: 1
    },
    {
      key: 'M/μL',
      scale: 1
    }
  ],
  // 白细胞
  WBC_UnitConversion: [
    {
      key: '10^9/L',
      scale: 1
    },
    {
      key: 'G/L',
      scale: 1
    },
    {
      key: 'Gpt/L',
      scale: 1
    },
    {
      key: '10^9 cells/L',
      scale: 1
    },
    {
      key: '10^3/μL',
      scale: 1
    },
    {
      key: '10^3/mm^3',
      scale: 1
    },
    {
      key: 'K/μL',
      scale: 1
    },
    {
      key: 'K/mm^3',
      scale: 1
    },
    {
      key: '10^3 cells/μL',
      scale: 1
    },
    {
      key: '10^3 cells/mm^3',
      scale: 1
    }
  ],
  // 钾（K）、钠（Na）单位换算关系
  Unit_conversion_of_common_ions: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'mEq/L',
      scale: 1
    }
  ],
  Unit_conversion_of_common_ions_ca: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mEq/L',
      scale: 2
    },
    {
      key: 'mg/dL',
      scale: 4.008
    },
    {
      key: 'mg/L',
      scale: 40.08
    },
    {
      key: 'μg/mL',
      scale: 40.08
    },
    {
      key: 'mg/100mL',
      scale: 4.008
    }
  ],
  Unit_conversion_of_common_ions_ma: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mEq/L',
      scale: 2
    },
    {
      key: 'mg/dL',
      scale: 2.431
    },
    {
      key: 'mg/L',
      scale: 24.31
    },
    {
      key: 'μg/mL',
      scale: 24.31
    },
    {
      key: 'mg/100mL',
      scale: 2.431
    }
  ],
  Unit_conversion_of_common_ions_fe: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mmol/L',
      scale: 0.001
    },
    {
      key: 'μg/dL',
      scale: 5.585
    },
    {
      key: 'μg/L',
      scale: 55.84
    },
    {
      key: 'ng/mL',
      scale: 55.85
    },
    {
      key: 'μg/100mL',
      scale: 5.584
    }
  ],
  Unit_conversion_of_common_ions_cu: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mmol/L',
      scale: 0.001
    },
    {
      key: 'μg/dL',
      scale: 6.355
    },
    {
      key: 'μg/L',
      scale: 63.55
    },
    {
      key: 'ng/mL',
      scale: 63.55
    },
    {
      key: 'μg/100mL',
      scale: 6.355
    }
  ],
  Unit_conversion_of_common_ions_zn: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mmol/L',
      scale: 0.001
    },
    {
      key: 'μg/dL',
      scale: 6.539
    },
    {
      key: 'μg/L',
      scale: 65.39
    },
    {
      key: 'ng/mL',
      scale: 65.39
    },
    {
      key: 'μg/100mL',
      scale: 6.539
    }
  ],
  Unit_conversion_of_common_ions_li: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: '10^3 μmol/L',
      scale: 1
    },
    {
      key: 'mEq/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.6941
    },
    {
      key: 'mg/L',
      scale: 6.941
    },
    {
      key: 'μg/mL',
      scale: 6.941
    },
    {
      key: 'mg/100mL',
      scale: 0.6941
    }
  ],
  Unit_conversion_of_common_ions_p: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: '10^3 μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 3.097
    },
    {
      key: 'mg/L',
      scale: 30.97
    },
    {
      key: 'μg/mL',
      scale: 30.97
    },
    {
      key: 'mg/100mL',
      scale: 3.097
    }
  ],
  IgE: [
    {
      key: 'IU/mL',
      scale: 1
    },
    {
      key: 'kU/L',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 2.42
    },
    {
      key: 'ng/dL',
      scale: 242
    },
    {
      key: 'ng/100mL',
      scale: 242
    },
    {
      key: 'μg/L',
      scale: 2.42
    }
  ],
  IgA: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 16
    },
    {
      key: 'mg/mL',
      scale: 0.16
    },
    {
      key: 'g/L',
      scale: 0.16
    },
    {
      key: 'mg/100mL',
      scale: 16
    }
  ],
  ammonia: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: '10^-3 mmol/L',
      scale: 1
    },
    {
      key: 'μg/L',
      scale: 17.03
    },
    {
      key: 'μg/dL',
      scale: 1.703
    },
    {
      key: 'μg/mL',
      scale: 0.01703
    },
    {
      key: 'mg/L',
      scale: 0.01703
    }
  ],
  Methanol: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/L',
      scale: 32.04
    },
    {
      key: 'mg/dL',
      scale: 3.204
    },
    {
      key: 'μg/mL',
      scale: 32.04
    },
    {
      key: 'mg/100mL',
      scale: 3.204
    }
  ],
  albumin: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'g/L',
      scale: 66.458
    },
    {
      key: 'g/dL',
      scale: 6.6458
    },
    {
      key: 'mg/mL',
      scale: 66.458
    },
    {
      key: 'g/100mL',
      scale: 6.6458
    }
  ],
  Gastrin_unit_conversion: [
    {
      key: 'pmol/L',
      scale: 1
    },
    {
      key: 'ng/L',
      scale: 2.098
    },
    {
      key: 'ng/dL',
      scale: 0.2098
    },
    {
      key: 'ng/100mL',
      scale: 0.2098
    },
    {
      key: 'pg/mL',
      scale: 2.098
    }
  ],
  // 雌二醇（E2）
  estradiol: [
    {
      key: 'pmol/L',
      scale: 1
    },
    {
      key: 'pg/L',
      scale: 272.386
    },
    {
      key: 'pg/dL',
      scale: 27.2386
    },
    {
      key: 'pg/mL',
      scale: 0.272386
    },
    {
      key: 'pg/100mL',
      scale: 27.2386
    },
    {
      key: 'ng/L',
      scale: 0.272386
    }
  ],
  // 白细胞介素-6（IL-6）
  IL_six: [
    {
      key: 'pg/mL',
      scale: 1
    },
    {
      key: 'ng/L',
      scale: 1
    },
    {
      key: 'pg/L',
      scale: 1000
    },
    {
      key: 'pg/dL',
      scale: 100
    },
    {
      key: 'pg/100mL',
      scale: 100
    }
  ],
  // 甲胎蛋白（AFP）
  AFP: [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'μg/L',
      scale: 1
    },
    {
      key: 'IU/mL',
      scale: 0.83
    }
  ],
  // 类风湿因子（RF）
  RF: [
    {
      key: 'U/mL',
      scale: 1
    },
    {
      key: 'kU/L',
      scale: 1
    },
    {
      key: 'IU/mL',
      scale: 1
    },
    {
      key: 'kIU/L',
      scale: 1
    }
  ],
  // 乙醇
  ethanol: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/L',
      scale: 46.07
    },
    {
      key: 'mg/dL',
      scale: 4.607
    },
    {
      key: 'mg/100mL',
      scale: 4.607
    },
    {
      key: ' μg/mL',
      scale: 46.07
    }
  ],
  // 癌抗原15-3（CA15-3）
  Cancer_Antigen_15_3: [
    {
      key: 'kU/L',
      scale: 1
    },
    {
      key: 'U/mL',
      scale: 1
    }
  ],
  // 癌抗原19-9（CA19-9）
  Carbohydrate_Antigen_19_9: [
    {
      key: 'kU/L',
      scale: 1
    },
    {
      key: 'U/mL',
      scale: 1
    }
  ],
  // 总三碘甲状腺原氨酸（T3）
  Triiodothyronine: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 0.651
    },
    {
      key: 'ng/dL',
      scale: 65.0978
    },
    {
      key: 'ug/L',
      scale: 0.651
    }
  ],
  // 色氨酸(Trp)
  Tryptophan: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0204
    },
    {
      key: 'mg/100mL',
      scale: 0.0204
    },
    {
      key: 'mg%',
      scale: 0.0204
    },
    {
      key: 'mg/L',
      scale: 0.2042
    },
    {
      key: 'μg/mL',
      scale: 0.2042
    }
  ],
  // 神经元特异性烯醇化酶（NSE）
  Neuron_Specific_Enolase: [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 100
    },
    {
      key: 'ng/100mL',
      scale: 100
    },
    {
      key: 'ng%',
      scale: 100
    },
    {
      key: 'ng/L',
      scale: 1000
    },
    {
      key: 'μg/L',
      scale: 1
    }
  ],
  // 生长分化因子-15（GDF-15）
  Growth_Differentiation_Factor_15: [
    {
      key: 'pg/mL',
      scale: 1
    },
    {
      key: 'pg/dL',
      scale: 100
    },
    {
      key: 'pg/100mL',
      scale: 100
    },
    {
      key: 'pg%',
      scale: 100
    },
    {
      key: 'pg/L',
      scale: 1000
    },
    {
      key: 'ng/L',
      scale: 1
    }
  ],
  // 生物素(维生素B7)
  Biotin: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'pg/mL',
      scale: 240
    },
    {
      key: 'ng/L',
      scale: 240
    },
    {
      key: 'ng/dL',
      scale: 24
    },
    {
      key: 'ng%',
      scale: 24
    }
  ],
  // 视黄醇（维生素A）
  Retinol: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 28
    },
    {
      key: 'μg/100mL',
      scale: 28
    },
    {
      key: 'μg%',
      scale: 28
    },
    {
      key: 'μg/L',
      scale: 280
    },
    {
      key: 'ng/mL',
      scale: 280
    }
  ],
  // 水杨酸盐
  Salicylate: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 13.81
    },
    {
      key: 'mg/100mL',
      scale: 13.81
    },
    {
      key: 'mg%',
      scale: 13.81
    },
    {
      key: 'ng/mL',
      scale: 138.1
    },
    {
      key: 'ng/mL',
      scale: 138.1
    }
  ],
  // 丝氨酸
  Serine: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0105
    },
    {
      key: 'mg/100mL',
      scale: 0.0105
    },
    {
      key: 'mg%',
      scale: 0.0105
    },
    {
      key: 'mg/mL',
      scale: 0.1051
    },
    {
      key: 'μg/mL',
      scale: 0.1051
    }
  ],
  // 苏氨酸（Thr）
  Threonine: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0119
    },
    {
      key: 'mg/100mL',
      scale: 0.0119
    },
    {
      key: 'mg%',
      scale: 0.0119
    },
    {
      key: 'mg/L',
      scale: 0.1191
    },
    {
      key: 'μg/mL',
      scale: 0.1191
    }
  ],
  // 酸性磷酸酶（ACP）
  Acid_Phosphatase: [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min•L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h•L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h•mL)',
      scale: 0.0036
    }
  ],
  // 糖化血红蛋白（HbA1c）与平均血糖（eAG）的换算
  Hemoglobin_A1c1: [
    {
      title: 'HbA1c（%）',
      desc: '有效范围4-13',
      scale: 1,
      min: 4,
      max: 13
    }
  ],
  Hemoglobin_A1c2: [
    {
      title: 'HbA1c（mmol/mol）',
      desc: '有效范围0-150',
      scale: 1,
      min: 0,
      max: 150
    }
  ],
  Hemoglobin_A1c3: [
    {
      title: '平均血糖（mg/dL）',
      desc: '有效范围0-414',
      scale: 1,
      min: 0,
      max: 414
    }
  ],
  Hemoglobin_A1c4: [
    {
      title: '平均血糖（mmol/L）',
      desc: '有效范围0-23',
      scale: 1,
      min: 0,
      max: 23
    }
  ],
  // 胎盘生长因子（PIGF）
  Placental_Growth_Factor: [
    {
      key: 'pg/mL',
      scale: 1
    },
    {
      key: 'pg/dL',
      scale: 100
    },
    {
      key: 'pg/100mL',
      scale: 100
    },
    {
      key: 'pg%',
      scale: 100
    },
    {
      key: 'pg/L',
      scale: 1000
    },
    {
      key: 'ng/L',
      scale: 1
    }
  ],
  // 碳酸氢盐（HCO3-）
  Bicarbonate: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mEq/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 6.1017
    },
    {
      key: 'mg/100mL',
      scale: 6.1017
    },
    {
      key: 'mg%',
      scale: 6.1017
    },
    {
      key: 'mg/L',
      scale: 61.0168
    },
    {
      key: 'μg/mL',
      scale: 61.0168
    }
  ],
  // 天冬氨酸（Asp）
  Aspartic_Acid: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0133
    },
    {
      key: 'mg/100mL',
      scale: 0.0133
    },
    {
      key: 'mg%',
      scale: 0.0133
    },
    {
      key: 'mg/L',
      scale: 0.1331
    },
    {
      key: 'μg/mL',
      scale: 0.1331
    }
  ],
  // 天冬氨酸氨基转移酶（AST/SGOT）
  Aspartate_Aminotransferase: [
    {
      key: 'nkat/L',
      scale: 1
    },
    {
      key: 'μkat/L',
      scale: 0.001
    },
    {
      key: 'U/L',
      scale: 0.06
    },
    {
      key: 'IU/L',
      scale: 0.06
    },
    {
      key: 'μmol/(min•L)',
      scale: 0.06
    },
    {
      key: 'μmol/(h•L)',
      scale: 3.6
    },
    {
      key: 'μmol/(h•mL)',
      scale: 0.0036
    }
  ],
  // 天冬酰胺（Asn）
  Asparagine: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0132
    },
    {
      key: 'mg/100mL',
      scale: 0.0132
    },
    {
      key: 'mg%',
      scale: 0.0132
    },
    {
      key: 'mg/L',
      scale: 0.1321
    },
    {
      key: 'μg/mL',
      scale: 0.1321
    }
  ],
  // 铁蛋白
  Ferritin: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'pmol/L',
      scale: 1000
    },
    {
      key: 'μg/dL',
      scale: 44.5
    },
    {
      key: 'μg/100mL',
      scale: 44.5
    },
    {
      key: 'μg%',
      scale: 44.5
    },
    {
      key: 'μg/L',
      scale: 445
    },
    {
      key: 'ng/mL',
      scale: 445
    }
  ],
  // 铜蓝蛋白（CP）
  Ceruloplasmin: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'g/L',
      scale: 134
    },
    {
      key: 'mg/dL',
      scale: 13400
    },
    {
      key: 'mg/100mL',
      scale: 13400
    },
    {
      key: 'mg%',
      scale: 13400
    },
    {
      key: 'mg/mL',
      scale: 134
    }
  ],
  // 维生素C（抗坏血酸）
  Ascorbic_Acid: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0176
    },
    {
      key: 'mg/100mL',
      scale: 0.0176
    },
    {
      key: 'mg%',
      scale: 0.0176
    },
    {
      key: 'mg/L',
      scale: 0.1761
    },
    {
      key: 'μg/mL',
      scale: 0.1761
    }
  ],
  // 维生素D总量
  Total_Vitamin_D: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'ng/mL',
      scale: 0.4
    },
    {
      key: 'ng/dL',
      scale: 40
    },
    {
      key: 'ng/100mL',
      scale: 40
    },
    {
      key: 'ng%',
      scale: 40
    },
    {
      key: 'ng/L',
      scale: 400
    },
    {
      key: 'μg/L',
      scale: 0.4
    }
  ],
  // 维生素B1（硫胺素）
  Thiamine: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 0.0337
    },
    {
      key: 'μg/100mL',
      scale: 0.0337
    },
    {
      key: 'μg%',
      scale: 0.0337
    },
    {
      key: 'μg/L',
      scale: 0.3373
    },
    {
      key: 'ng/mL',
      scale: 0.3373
    }
  ],
  // 维生素B3（烟酸）
  Niacin: [
    {
      key: 'μg/dL',
      scale: 1
    },
    {
      key: 'μg/100mL',
      scale: 1
    },
    {
      key: 'μg%',
      scale: 1
    },
    {
      key: 'μg/L',
      scale: 10
    },
    {
      key: 'ng/mL',
      scale: 10
    },
    {
      key: 'μg/mL',
      scale: 0.01
    }
  ],
  // 维生素B6（磷酸吡哆醛）
  Pyridoxine: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 0.0247
    },
    {
      key: 'μg/100mL',
      scale: 0.0247
    },
    {
      key: 'μg%',
      scale: 0.0247
    },
    {
      key: 'μg/L',
      scale: 0.2471
    },
    {
      key: 'ng/mL',
      scale: 0.2471
    }
  ],
  // 维生素B12（氰钴胺）
  Cobalamin: [
    {
      key: 'pmol/L',
      scale: 1
    },
    {
      key: 'pg/mL',
      scale: 1.3554
    },
    {
      key: 'pg/dL',
      scale: 135.537
    },
    {
      key: 'pg/100mL',
      scale: 135.537
    },
    {
      key: 'pg%',
      scale: 135.537
    },
    {
      key: 'pg/L',
      scale: 1355.37
    },
    {
      key: 'ng/L',
      scale: 1.3554
    }
  ],
  // 妥布霉素
  Tobramycin: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0468
    },
    {
      key: 'mg/100mL',
      scale: 0.0468
    },
    {
      key: 'mg%',
      scale: 0.0468
    },
    {
      key: 'mg/L',
      scale: 0.4675
    },
    {
      key: 'μg/mL',
      scale: 0.4675
    }
  ],
  // 万古霉素
  Vancomycin: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.1449
    },
    {
      key: 'mg/100mL',
      scale: 0.1449
    },
    {
      key: 'mg%',
      scale: 0.1449
    },
    {
      key: 'mg/L',
      scale: 1.4493
    },
    {
      key: 'μg/mL',
      scale: 1.4493
    }
  ],
  // 1,25-二羟基维生素D3（骨化三醇）
  Calcitriol: [
    {
      key: 'pmol/L',
      scale: 1
    },
    {
      key: 'pg/mL',
      scale: 0.4166
    },
    {
      key: 'ng/dL',
      scale: 0.0417
    },
    {
      key: 'ng/100mL',
      scale: 0.0417
    },
    {
      key: 'ng%',
      scale: 0.0417
    },
    {
      key: 'ng/L',
      scale: 0.4166
    }
  ],
  // 25-羟基维生素D3（25-羟基维生素D）
  '25_Hydroxyvitamin_D': [
    {
      key: 'ng/mL',
      scale: 1
    },
    {
      key: 'nmol/L',
      scale: 2.496
    },
    {
      key: 'μg/L',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 0.1
    },
    {
      key: 'μg/100mL',
      scale: 0.1
    }
  ],
  // 维生素E（α-生育酚）
  Vitamin_E: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0431
    },
    {
      key: 'mg/100mL',
      scale: 0.0431
    },
    {
      key: 'mg%',
      scale: 0.0431
    },
    {
      key: 'mg/L',
      scale: 0.4307
    },
    {
      key: 'μg/mL',
      scale: 0.0431
    }
  ],
  // 维生素K（叶绿醌）
  Phylloquinone: [
    {
      key: 'nmol/L',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 0.0451
    },
    {
      key: 'μg/100mL',
      scale: 0.0451
    },
    {
      key: 'μg%',
      scale: 0.0451
    },
    {
      key: 'μg/L',
      scale: 0.4507
    },
    {
      key: 'ng/mL',
      scale: 0.4507
    }
  ],
  // 胃泌素释放肽前体（ProGRP）
  Pro_gastrin_releasing_peptide: [
    {
      key: 'pg/mL',
      scale: 1
    },
    {
      key: 'pg/dL',
      scale: 100
    },
    {
      key: 'pg/100mL',
      scale: 100
    },
    {
      key: 'pg%',
      scale: 100
    },
    {
      key: 'pg/L',
      scale: 1000
    },
    {
      key: 'ng/L',
      scale: 1
    }
  ],
  // 硒代半胱氨酸（Sec）
  Selenocysteine: [
    {
      key: 'μmol/L',
      scale: 1
    },
    {
      key: 'mg/dL',
      scale: 0.0168
    },
    {
      key: 'mg/100mL',
      scale: 0.0168
    },
    {
      key: 'mg%',
      scale: 0.0168
    },
    {
      key: 'mg/L',
      scale: 0.1681
    },
    {
      key: 'μg/mL',
      scale: 0.1681
    }
  ],
  // 细胞角蛋白19片段（CYFRA 21-1）
  Cytokeratin_19_Fragment: [
    {
      key: 'μg/mL',
      scale: 1
    },
    {
      key: 'μg/dL',
      scale: 0.1
    },
    {
      key: 'μg/100mL',
      scale: 0.1
    },
    {
      key: 'ng%',
      scale: 0.1
    },
    {
      key: 'ng/mL',
      scale: 1
    }
  ],
  // 镁
  Magnesium: [
    {
      key: 'mmol/L',
      scale: 1
    },
    {
      key: 'μmol/L',
      scale: 1000
    },
    {
      key: 'mg/L',
      scale: 24.305
    },
    {
      key: 'mg/dL',
      scale: 2.4305
    },
    {
      key: 'mg/100mL',
      scale: 2.4305
    },
    {
      key: 'μg/mL',
      scale: 24.305
    },
    {
      key: 'mEg/L',
      scale: 2
    }
  ],
  // 胰高血糖素
  Glucagon: [
    {
      key: 'ng/L',
      scale: 1
    },
    {
      key: 'pg/mL',
      scale: 1
    },
    {
      key: 'ng/dL',
      scale: 0.1
    },
    {
      key: 'ng/100mL',
      scale: 0.1
    },
    {
      key: 'ng%',
      scale: 0.1
    }
  ]

}
export default filterJson



// WEBPACK FOOTER //
// ./src/utils/filter/filter.js